const w = window;
w.pgm = "(min-width: 450px)";
w.msm = "(max-width: 1059px)";
w.legacy = '';
w.clickedButton;
w.tabsApplied = false;
w.st = 0;
w.ap = Array.prototype;
const cver = '2';
const de = document.documentElement;
const raf = window.requestAnimationFrame;
const idl = window.requestIdleCallback

// Testing for need for camelCase conversion
const cTest = new RegExp(/[- ]/);
// Short hand way to get data attributes cross browser
w.ds = (n,s,v) => {
    if(v || v === 0) {
        if(n.dataset) {
            n.dataset[cTest.test(s)?camelize(s):s] = v;
        } else {
            n.setAttribute('data-' + s, v);
        }
    } else {
        if(n.dataset) {
            return n.dataset[cTest.test(s)?camelize(s):s];
        } else {
            return n.getAttribute('data-' + s);
        }
    }
}
//Short hand for query selector
w.qs = (s,p) => {
    if(p) {
        return p.querySelector(s);
    } else {
        return document.querySelector(s);
    }
}
//Short hand for querySelectorAll
w.qa = (s,p) => {
    if(p) {
        return p.querySelectorAll(s);
    } else {
        return document.querySelectorAll(s);
    }
}
//Short hand for for each
w.fe = (arr,iterate) => {
    ap.forEach.call(arr,iterate);
}
//Converting camelcase to the format the site uses for category filters
const camelize = str => {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '').replace(/--/g, '~').replace(/-$/g, '~').replace(/-/g, '').replace(/~/g, '-');
}

//Checks a nodeList of images and marks them as loaded if loaded or onload, triggering the rows to reequalise if in specific parent
w.imgLoadEvents = imgs => {
    fe(imgs, a => {
        if((typeof a.naturalWidth == 'number' && typeof a.naturalHeight == 'number' && !(a.naturalWidth == 0 && a.naturalHeight == 0)) || a.complete || a.src.indexOf('.svg') > -1) {
            a.classList.add('loaded'); 
        } else {
            a.addEventListener('load',() => {
                a.classList.add('loaded'); 
            });
        }
    }); 
}
w.populateBasket = (data) => {
    if((data.basket && data.basket !== null) || (data.quote && data.quote !== null && data.quote.item_count > 0)) {
        const total_incvat = data.basket?data.basket.total_incvat?data.basket.total_incvat:data.basket.total:0;
        const total_excvat = data.basket?data.basket.total_exvat?data.basket.total_exvat:data.basket.subtotal:0;
        const itemCount = data.basket?data.basket.item_count?data.basket.item_count:data.basket.items.length:0;
        let mb = '<span class="baskethead headlink" '; 
        if(data.basket) {
            mb += 'title="&pound;' + currencyPad(total_incvat) + ' inc. VAT, &pound;' + currencyPad(total_excvat) + ' ex. VAT "';
        }
        mb += '><a href="/shop/basket/" class="iconholder">';
        if(data.basket) {
            mb += '<span class="basketcorner">'+itemCount+'</span>';
        }
        mb += '<span class="icon-basket icon"><span>Basket</span></span><span class="basketlabel">Your Basket</span></a><span class="hovercontent">';

        if(data.basket) {
            mb += '<span class="items">'+itemCount+'&nbsp;Item' + (itemCount > 1?'s':'') + ' in your Basket</span>';
            mb += '<span class="totals"><strong class="big">Total: <span class="incvat">&pound;' + currencyPad(total_incvat) + ' <span class="vattag">inc. VAT</span></span><span class="exvat">&pound;' + currencyPad(total_excvat) + ' <span class="vattag">ex. VAT</span></span></strong></span>';
            mb+='<a href="/shop/basket/" class="btn">View Basket</a>&nbsp;<a href="/shop/checkout/" class="btn bbtn">Checkout</a>';
        } else {
            mb += '<a href="/products/quote.php" class="pbtn btn">View Quote</a>&nbsp;';
        }
        mb += '</span></span>';
        const bc = qs('.basketcorner');
        if(bc && data.basket) {
            bc.textContent = itemCount;
        }
        document.getElementById('mb').innerHTML = mb;
    }
}
// Runs when DOM ready
const activatePage = () => {

    // Document element dom ready class check to prevent repeats
    if(!ds(de,'jsenabled')) {
        setTimeout(() => {
            ds(de,'jsenabled',true);    
        },0);

        pwrap = qs('.products_wrapper');
        imgLoadEvents(qa('img[loading="lazy"]',pwrap));

        if(typeof gapvc == 'function') {
            gapvc(); 
        }

        //Session features e.g. Basket and recently viewed items
        const getRecentProducts = () => {
            fetch('/session.php')
            .then(res => res.json())
            .then(data => {
                populateBasket(data);
                if(data.compare_products && data.compare_products.length > 0) {
                    fe(data.compare_products, s => {
                        const n = qs('#comp'+s);
                        if(n) {
                            n.innerHTML = '<a href="/products/compare/" class="comparelink">View Compare <span class="icon-compare icon"></span></a>';
                        }
                    });
                }
                if(data.customer) {
                    const n = qs('.wish');
                    if(n) {
                        n.innerHTML = '<button type="submit" name="destination" value="wishlist" class="textbutton add_wishlist wishlist_loggedin" data-value="wishlist" id="wishlist_basket" onclick="clickedButton=\'wishlist_basket\';" >Wishlist <span class="icon-heart-o icon"></span></button>';
                    }
                }

                if(data.business && data.business.phone_line) {
                    const ot = data.business.phone_line;
                    const hoursMessage = qs("#openhours");
                    const phoneNumberNode = qs('.phonenumber');

                    const generateDateFields = (d) => {
                        let month = '' + (d.getMonth() + 1);
                        let day = '' + d.getDate();
                        let year = d.getFullYear();

                        if (month.length < 2) {
                            month = '0' + month;
                        }
                        if (day.length < 2) {
                            day = '0' + day;
                        }
                        var options = { weekday: 'short' };
                        return {
                            year:year,
                            month:month,
                            day:day,
                            date:[year, month, day].join('-'),
                            day3:new Intl.DateTimeFormat('en-UK', options).format(d).toUpperCase()
                        }
                    }

                    const checkTime = () => {
                        const pl = new Date();
                        const dateDetails = generateDateFields(pl);
                        
                        const openSplit = ot.regular_hours.open.split(':');
                        const closeSplit = ot.regular_hours.close.split(':');
                        let open = false;
                        if(ot.regular_hours.days.indexOf(dateDetails.day3) > -1 && ot.closed_dates.indexOf(dateDetails.date) == -1) {
                            if((pl.getHours() > Number(openSplit[0]) || (pl.getHours() == Number(openSplit[0]) && pl.getMinutes() > Number(openSplit[1]))) &&
                                (pl.getHours() < Number(closeSplit[0]) || (pl.getHours() == Number(closeSplit[0]) && pl.getMinutes() < Number(closeSplit[1])))) {
                                open = true;
                            }
                        }
                        if(open) {
                            hoursMessage.innerHTML = "We are <strong class='normal'>open</strong>, we close at " + ot.regular_hours.close + '.<br />Call us:';
                            phoneNumberNode.classList.remove('disabled');
                        } else {
                            let newText = "We are <strong class='normal'>closed</strong>, we open again ";
                            let nextOpen = new Date();
                            nextOpen.setTime(pl.getTime());
                            let daysCount = 0;
                            if(pl.getHours() > Number(closeSplit[0]) || (pl.getHours() == Number(closeSplit[0]) && pl.getMinutes() > Number(closeSplit[1]))) {
                                nextOpen.setTime(nextOpen.getTime() + 86400000);
                                daysCount = 1;
                            }
                            let nextDetails = generateDateFields(nextOpen);
                            while((ot.regular_hours.days.indexOf(nextDetails.day3) == -1 || ot.closed_dates.indexOf(nextDetails.date) > -1) && daysCount < 14) {
                                nextOpen.setTime(nextOpen.getTime() + 86400000);
                                nextDetails = generateDateFields(nextOpen);
                                daysCount++;
                            }
                            if(daysCount < 14) {
                                if(nextDetails.date == dateDetails.date) {
                                    if(nextOpen.getHours() < Number(openSplit[0]) || (nextOpen.getHours() == Number(openSplit[0]) && nextOpen.getMinutes() < Number(openSplit[1]))) {
                                        newText += "at " + ot.regular_hours.open;
                                    }
                                }

                                if(nextDetails.date != dateDetails.date) {
                                    const dayoptions = { weekday: 'long' };
                                    newText += (daysCount == 1?'Tomorrow':new Intl.DateTimeFormat('en-UK', dayoptions).format(nextOpen)) + " at " + ot.regular_hours.open;
                                }

                                if(Intl.DateTimeFormat().resolvedOptions().timeZone.indexOf('London') == -1) {
                                    newText += ' UK Time';
                                }

                                hoursMessage.innerHTML = newText + '.<br />Our number is:'; 
                                if(!phoneNumberNode.classList.contains('disabled')) {
                                    phoneNumberNode.classList.add('disabled');
                                }
                            }
                        }
                    }

                    if(hoursMessage) {
                        checkTime();
                        setInterval(checkTime, 60000);
                    }
                    
                }

                if(data.recently_viewed_products && data.recently_viewed_products.length > 0) {
                    loadJS(asc+'/shop/js/recent-bundle.js?a', () => {
                        const ri = qs('#recentitems');
                        if(ri) {
                            if(ri.offsetTop > window.scrollY + window.innerHeight) {
                                displayRecent(ri, data.recently_viewed_products)
                            } else {
                                const loadRi = document.createElement('div');
                                loadRi.className = 'loadRi';
                                loadRi.setAttribute('role', 'link');
                                loadRi.textContent = 'Recently Viewed Items';
                                ri.appendChild(loadRi); 
                                loadRi.addEventListener('click', () => {
                                    displayRecent(ri, data.recently_viewed_products)
                                })
                            }
                        }
                    });
                }
            });
        }
        if (idl) idl(function() { window.setTimeout(getRecentProducts, 0); });
        else window.addEventListener('load', getRecentProducts);

        //Cookie notifications
        const cookienotified = document.cookie.match(/cookienotified=([^;]+)/);
        const cnv = cookienotified?cookienotified[1].match(/^([\d.]+),[0,1],[0,1](,[0,1])?$/):false; 
        if(!cookienotified || cookienotified[1]=='yes' || (cnv && cnv[1] != cver)) {
            if(location.href.indexOf('privacy-policy') > -1) {
                if(cookienotified) {
                    cprefs = cookienotified[1].split(',');
                    if(cprefs[1] == '1') {
                        gtag('consent', 'update', {'analytics_storage': 'granted'});
                        window.uetq.push('consent', 'update', {'ad_storage': 'granted'});
                    }
                    if(cprefs.length > 3 && cprefs[3] == '1') {
                        gtag('consent', 'update', {'ad_storage': 'granted','ad_user_data':'granted','ad_personalization':'granted'});
                    }
                }
                displaycookiePrefs(); 
            } else {
                if(location.href.indexOf('?nocookie') === -1) {
                    const cb = document.createElement('div');
                    cb.className = 'cookiebar'; 
                    cb.innerHTML = '<div><p class="h3"><strong>Select Cookie Preferences</strong></h3><p>This site uses cookies, while some are necessary for the site to work, you can choose to decline optional cookies. However some website features, like our live chat service, will disabled if you do this. For more details see our <a href="/privacy-policy#cookies">Cookie Policy</a></p><button type="button" class="btn gbtn" id="creject">Reject</button> <button type="button" class="btn gbtn" id="ccustomise">Options</button> <button type="button" class="btn bbtn" id="removeCB">Accept All</button></div>';
                    const h = qs('body');
                    h.insertBefore(cb, h.firstChild);
                    document.getElementById('ccustomise').addEventListener('click', () => {
                        displaycookiePrefs();
                    });
                    document.getElementById('creject').addEventListener('click', () => {
                        cprefs = [cver,'0','0','0'];
                        document.cookie="cookienotified="+cver+",0,0,0; path=/; expires=Thu, 31 Dec 2099 23:59:59;samesite=lax";
                        cb.parentNode.removeChild(cb);
                        gtag('consent', 'update', {'analytics_storage': 'denied'});
                        window.uetq.push('consent', 'update', {'ad_storage': 'denied'});
                    });
                    document.getElementById('removeCB').addEventListener('click', () => {
                        cprefs = [cver,'1','1','1'];
                        document.cookie="cookienotified="+cver+",1,1,1; path=/; expires=Thu, 31 Dec 2099 23:59:59;samesite=lax";
                        cb.parentNode.removeChild(cb);
                        if(window.pageloaded) {
                            dataLayer.push([{event:'page_view', page_title:w.document.title, page_location:location.href }]);
                        }
                        gtag('consent', 'update', {'analytics_storage': 'granted'});
                        window.uetq.push('consent', 'update', {'ad_storage': 'granted'});
                        gtag('consent', 'update', {'ad_storage': 'granted','ad_user_data':'granted','ad_personalization':'granted'});
                    });
                }
            }
        } else {
            if(cookienotified) { 
                cprefs = cookienotified[1].split(',');
                if(cprefs[1] == '1') {
                    gtag('consent', 'update', {'analytics_storage': 'granted'});
                    window.uetq.push('consent', 'update', {'ad_storage': 'granted'});
                }
                if(cprefs.length > 3 && cprefs[3] == '1') {
                    gtag('consent', 'update', {'ad_storage': 'granted','ad_user_data':'granted','ad_personalization':'granted'});
                }
                if(document.getElementById('ccustom')) {
                    displaycookiePrefs();
                }
            }
        }

      }

    // DOM ready horizontal scroller implementation
    const hshs = qa('.hscrollerholder');

    if(hshs.length > 0) {
        setupHScrollers(hshs);
    }

    // Selectbox links
    const slas = qa('.selectlista');
    if(slas.length > 0) {
        fe(slas,sla => {
            const s = createElement('select');
            s.addEventListener('change', () => {
                location.href = this.value;
            });
            fe(qa('a',sla),a => {
                const o = createElement('option');
                o.setAttribute('value', a.href);
                o.textContent = a.textContent;
                s.appendChild(o);
            });
            sla.innerHTML = '';
            sla.appendChild(s);
        });
    }

    // Simple expanders
    const eh = qa('.expand_head');
    if(eh.length > 0) {
        fe(eh, te => {
            let body = te.nextElementSibling;
            if(!body.classList.contains('expand_body')) {
                body = te.previousElementSibling;
            }
            const lbl = qs('.label',te);
            const closeBody = (e) => {
                if(te.classList.contains('active')){
                    const eb = e.target.closest('.expand_body');
                    if(!eb || e.target.nodeName == 'A' || e.target.nodeName == 'OPTION') {
                        slideUp(body);
                        if(lbl) {
                            lbl.textContent = 'Reveal more';
                        }
                        te.classList.remove('active');
                        document.body.removeEventListener('click',closeBody);
                    }
                }
            }
            te.addEventListener('click', (e) => {
                e.stopPropagation();
                if(te.classList.contains('active')){
                    closeBody(e);
                } else {
                    var sel = body.closest('.select');
                    if(sel) {
                        let otherActive = qs('.select .expand_head.active');
                        if(otherActive) {
                            let oabody = otherActive.nextElementSibling;
                            if(!oabody.classList.contains('expand_body')) {
                                oabody = otherActive.previousElementSibling;
                            }
                            oabody.style.display = '';
                            let oalbl = qs('.label',otherActive);
                            if(oalbl) {
                                oalbl.textContent = 'Reveal more';
                            }
                            otherActive.classList.remove('active');
                        }
                    }
                    slideDown(body);
                    if(sel) {
                        let bsh = body.scrollHeight;
                        let ehpos = te.getBoundingClientRect();
                        if(window.innerHeight < ehpos.bottom + bsh && ehpos.top > bsh) {
                            te.parentNode.classList.add('up');
                        } else {
                            te.parentNode.classList.remove('up');
                        }
                        document.body.addEventListener('click',closeBody);
                    }
                    if(lbl) {
                        lbl.textContent = 'Hide';
                    }
                    te.classList.add('active');
                }
            })
            if(!te.classList.contains('active')) {
                body.style.display = 'none';
            }
        });
    }

    //Seach input auto complete
    initAutoSearch(document.getElementById("search"));

    // Lease popup
    const bpage = qs('.basketpage');
    if(bpage){
        const obtn = qs(' .btn.obtn.disabled');
        if(obtn){
            loadJS(asc+'/shop/js/lease-pop-bundle.js', () => {
                obtn.addEventListener('click', addLeasePop);
            });
        }
    }
    
    //Fancybox replacement (cabox) call in if needed
    if(qs('.fancylink,.fancytrustwave,jspopup,.ufancylink,.fancytour')) {
        const activatePopFunctions = () => {
            if(w.caboxPoppedFunctions) {
                for(let i = 0;i < w.caboxPoppedFunctions.length;i++) {
                    w.caboxPoppedFunctions[i]();
                }
            }
        }
        cabox.init('.fancylink', {
            onComplete:activatePopFunctions
        });
        cabox.init('.fancytrustwave',{ type:'iframe', width:590, height:517 }); 
        cabox.init('.fancytour',{ type:'iframe', width:1100, height:640 }); 
        const ufancyboxes = qa('.ufancylink');
        if(ufancyboxes.length > 0) {
            fe(ufancyboxes, (l, i) => {
                l.classList.add('ufb' + i);
                if(w.ds(l, 'width')) {
                    cabox.init('.ufb' + i, {
                        onComplete:activatePopFunctions,
                        width:w.ds(l, 'width')
                    });
                } else {
                    cabox.init('.ufb' + i, {
                        onComplete:activatePopFunctions
                    });
                }
            })
        }
    }

    // Categories subnav
    const ne = qs('#navexpander');
    const nav = qs('#nav');
    if(ne) {
        fe(qa('.dl',ne),a => {
            a.addEventListener('click', e => {
                if(!a.parentNode.classList.contains('active')) {
                    const l = ds(a, 'list');
                    const t = qs('#navexpanderlist'+l);
                    let old = qs('#navexpander > li.active');
                    if(old) {
                        let oldDrop = qs('.drop',old);
                        if(oldDrop) {
                            oldDrop.classList.remove("slideDown");
                            oldDrop.classList.add('slideUp'); 
                            const removeActive = () => {
                                old.classList.remove('slideUp');
                                oldDrop.removeEventListener('animationend',removeActive);
                            }
                            oldDrop.addEventListener('animationend',removeActive);
                        }
                        old.classList.remove('active');
                    }
                    a.parentNode.classList.add('active');
                    if(!t.classList.contains("slideDown")) {
                        const v = ap.filter.call(t.parentNode.children, c => {
                            return c != t && c.offsetHeight > 0 && c.className == 'drop';
                        });
                        if(v.length > 0) {
                            fe(v, (n,i) => {
                                t.classList.remove("slideDown");
                            });
                            setTimeout(() => {
                                t.classList.add("slideDown");
                            }, 100);
                            const oa = qs('.active',a.parentNode.parentNode);
                            if(oa) {
                                oa.classList.remove('active');
                            }
                        } else {
                            t.classList.add("slideDown");
                        }
                        fe(t.parentNode.parentNode.children, c => {
                            if(c && c != t.parentNode && c.classList.contains('active')) {
                                c.classList.remove('active');
                            }
                        });
                    }
                    e.preventDefault();
                    nav.classList.add('on');
                }
            });
        });

        fe(qa('.drop',ne),(a, i) => {
            a.id = 'navexpanderlist'+i;
            const s = Array.prototype.filter.call(a.parentNode.children, child => {
              return child !== a && child.nodeName == 'A';
            })[0];
            ds(s,'list',i);
            /*const icon = document.createElement('div');
            icon.className = "icon nostockicon";
            icon.addEventListener('click',() => {
                slideUp(a);
                fe(qa('#navexpander .active'), n => {
                    n.classList.remove('active');
                });
            });
            const c = qs('.container',a);
            c.insertBefore(icon, c.firstChild);
            a.style.display = 'none';*/
        });
    }

    //Animated scrolling in page links
    fe(qa('.smoothscroll'),a => {
        a.addEventListener('click', e => {
            if(a.href.indexOf('#') > -1) {
                const hsh = a.href.split('#')[1];
                if(document.getElementById(hsh)) {
                    scrollToSel('#'+hsh);
                    history.pushState({}, '', '#' + hsh);
                    if(e) {
                        e.preventDefault();
                    }
                    return false;
                }
            }
        });
    });

    //Resize throttling
    
    setTimeout(() => {
        window.addEventListener('resize',throttle(initMobile,250));
        initMobile();
    },10);

    // incvat exvat switcher
    const b = document.body;
    if(cookievat && cookievat.length > 0) {
        b.className = b.className.replace(new RegExp('(ex|in)cvat','g'),'');
        b.classList.add(cookievat[1]);
    } else {
        b.classList.remove('excvat');
        b.classList.add('incvat');
    }
    const vs = document.getElementById('vatswitcher');
    if(vs) {
        vs.innerHTML =  '<p>Show prices: <label for="incvat">inc. VAT <input type="radio" name="vat" id="incvat" value="incvat" /></label> <label for="excvat">ex. VAT <input type="radio" name="vat" id="excvat" value="excvat" /></label></p>';
        if(cookievat && cookievat.length > 0) {
            qs(`#${cookievat[1]}`).setAttribute('checked',true);
        } else {
            qs('#incvat').setAttribute('checked',true);
        }
        fe(qa('input',vs), i => {
            i.addEventListener('change', a => {
                b.className = b.className.replace(new RegExp('(ex|in)cvat','g'),'');
                b.classList.add(a.value);
                document.cookie = 'cookievat='+this.value+';path=/;samesite=lax';
                if(dataLayer) {
                    dataLayer.push({event:'vat_switch', value:a.value });
                }
                const oa = qs('#optionsaccessories')
                if(oa) {
                    fe(qs('option',oa), o => {
                        if(ds(oa, 'name')) {
                            if(b.classList.contains('incvat')) {
                                o.innerHTML = `${ds(oa, 'name')} + &pound;${currencyPad(ds(o,'vatprice'))}`;
                            } else {
                                o.innerHTML = `${ds(oa, 'name')} + &pound;${currencyPad(ds(o,'price'))}`;
                            }
                        }
                    });
                    refreshProductPrices();
                }
            });
        });
    }

    fe(qa('.offer, .product_price, td.price, .a_p, .vat_switch_holder, .vat_status'), n => {
        n.addEventListener('click', vatSwitcher);
    });

    if(qs('.vat_container')) {

        let dragging;
        fe(window.proddata?qa('.vat_switch_back'):[qs('.vat_switch_back',vs)], bar => {
            const sh = qs('.vat_switch',bar);
            let startX;
            const vstart = e => {
                startX = e.pageX;
                if(!startX) {
                    const touch = e.touches[0] || e.changedTouches[0];
                    startX = touch.pageX;
                }
                dragging = true;
                e.stopPropagation();
                return false;
            }
            const vend = e => {
                const wasDragging = dragging;
                dragging = false;
                let x = e.pageX;
                if(!x && e) {
                    if(e.touches) {
                        const touch = e.touches[0] || e.changedTouches[0];
                        x = touch.pageX;
                    } else {
                        x = 0;
                    }
                }
                const barpos = bar.getBoundingClientRect();
                const shpos = sh.getBoundingClientRect();
                if(typeof startX != 'undefined' && startX != x && wasDragging) {
                    if(shpos.left < barpos.left + ((bar.offsetWidth-sh.offsetWidth)/2)) {
                        activateExcVat();
                    } else {
                        activateIncVat();
                    }
                } else {
                    if(shpos.left < barpos.left + ((bar.offsetWidth-sh.offsetWidth)/2)) {
                        activateIncVat();
                    } else {
                        activateExcVat();
                    }
                }
                Object.assign(sh.style, {
                    left:'',
                    transform:'',
                    transition:''
                });
                startX = false;
                return false;
            }
            const vmove = e => {
                if(dragging) {
                    let x = e.pageX;
                    if(!x) {
                        const touch = e.touches[0] || e.changedTouches[0];
                        x = touch.pageX;
                    }
                    const barpos = bar.getBoundingClientRect()
                    let target = Math.min((x-barpos.left),bar.offsetWidth)/bar.offsetWidth;
                    if(target <= 0) {
                        target = 0;
                    } else if(target >= 1) {
                        target = 1;
                    }
                    if(target < 0.5) {
                        activateExcVat();
                    } else {
                        activateIncVat();
                    }
                    Object.assign(sh.style, {'left':(target * 100)+'%', 'transform':'translate(-'+(target * 100)+'%,0)', transition:'none'});
                }
            }
            sh.addEventListener('mousedown', vstart);
            sh.addEventListener('touchstart', vstart, { passive: true });
            bar.addEventListener('mouseout', e => {
                if(dragging) {
                    const evt = document.createEvent("MouseEvents");
                    evt.initEvent("mouseup", true, true);
                    e.target.dispatchEvent(evt);
                }
            });
            bar.addEventListener('mouseup',vend);
            bar.addEventListener('touchend',vend);
            bar.addEventListener('mousemove',vmove);
            bar.addEventListener('touchmove',vmove, { passive: true });
            bar.addEventListener('click',() => { return false; });
        });
    }

    // Expander styles
    const aeh = qa('.expander_head');
    if(aeh.length > 0) {
        fe(aeh,h => {
            const eb = qs('.expander_body',h.parentNode);
            h.addEventListener('click', () => {
                if(eb.offsetHeight > 0) {
                    h.classList.remove('active');
                    slideUp(eb);
                } else {
                    h.classList.add('active');
                    slideDown(eb);
                }
            })
            if(!h.classList.contains('active')) {
                eb.style.display = 'none';
            }
        });
    }

    //Styles select boxes (checkout)
    const radios = qa('.radio input');
    if(radios.length > 0) {
        fe(radios, n => {
            n.addEventListener('change', () => {
                if(n.checked) {
                    fe(radios, r => {
                        if(r.name == n.name && r.value != r.value) {
                            qs('.radiostatus',r.parentNode).textContent = 'Select';
                        }
                    });
                    qs('.radiostatus',n.parentNode).textContent = 'Selected';
                }
            });
            if(n.checked) {
                qs('.radiostatus',n.parentNode).textContent = 'Selected';
            }
        })
    }

    //Dynamically load includes and sticky scroll styles
    const dloads = qa('.dLoad');
    const loader = document.createElement('div');
    loader.className = 'loaderholder';
    loader.innerHTML = '<div class="loader"></div>';
    let categoryData = [];
    let called = [];
    let lastHovered = null;
    const catChildrenHTML = (catdata) => {
        if(catdata.children) {
            return `${catdata.children.map((c,i) => {
                if(c.num_listed_products > 0 || !c.children || (c.children && c.children.length > 0)) {
                    return `<li><a draggable="false" title="${c.name}" href="${c.url}" data-id="${c.id}"${(c.children && c.children.length > 0)?'class="hasChildren"':''}>${c.name}</span></a></li>`;
                } else {
                    return '';
                }
            }).join('')}`;
        }
    }

    let navcontroller;

    const overCat = (e) => {
        if(!e.target.parentNode.classList.contains('active') && e.target.classList.contains('hasChildren')) {
            e.preventDefault();
            if((e.type == 'mouseenter' && !window.matchMedia(msm).matches) || (e.type == 'click' && window.matchMedia(msm).matches)) {
                const a = e.target;
                const id = ds(a,'id');
                const catDataIndex = categoryData.findIndex(d => d.id == id);
                const ul = a.closest('.ul');
                while (ul.nextElementSibling) {
                    ul.nextElementSibling.remove();
                }
                const last = qs('.active',ul);
                if(last) {
                    last.classList.remove('active');
                }
                a.parentNode.classList.add('active');
                if(catDataIndex > -1) {
                    if(categoryData[catDataIndex].children && categoryData[catDataIndex].children.length > 0) {
                        const nextul = document.createElement('div');
                        nextul.classList.add('ul')
                        nextul.innerHTML = `<div class="scrlup"></div><ul>${catChildrenHTML(categoryData[catDataIndex])}</ul><div class="scrldn"></div>`;
                        if(!window.matchMedia(msm).matches) {
                            ul.after(nextul);
                        } else {
                            a.after(nextul);
                        }
                        lastHovered = {id:Number(id),event:e};
                        setupCatNavLinks(nextul);
                    }
                    if(categoryData[catDataIndex].children && categoryData[catDataIndex].children.length > 0) {
                        const ids = categoryData[catDataIndex].children.map(c => c.id).join(',');
                        if(navcontroller) {
                            navcontroller.abort('Operation cancelled by the user');
                        }
                        navcontroller = new AbortController();
                        if(called.indexOf(ids) == -1) {
                            fetch(`/api/nav/categories?root=${ids}&md=1`, {
                              signal: navcontroller.signal
                            }).then(res => res.json()).then(data => {
                                called.push(ids);
                                categoryData[catDataIndex].children = data.categories;
                                fe(data.categories, (c,i) => {
                                    const catDataIndex = categoryData.findIndex(d => d.id == c.id);
                                    if(catDataIndex > -1) {
                                        categoryData[catDataIndex] = c;
                                    } else {
                                        categoryData.push(c);
                                    }
                                    if(c.id == lastHovered.id) {
                                        overCat(lastHovered.event);
                                    }
                                    if(c.children.length > 0) {
                                        const ida = qs(`a[data-id="${c.id}"]`,ul.parentNode);
                                        if(!ida.classList.contains('hasChildren')) {
                                            ida.classList.add('hasChildren')
                                        }
                                        fe(c.children, cc => {
                                            const catDataIndex = categoryData.findIndex(d => d.id == cc.id);
                                            if(catDataIndex > -1) {
                                                categoryData[catDataIndex] = cc;
                                                if(cc.children && cc.children.length > 0) {
                                                    called.push(cc.id);
                                                }
                                                if(cc.id == lastHovered.id) {
                                                    overCat(lastHovered.event);
                                                }
                                            } else {
                                                categoryData.push(cc);
                                            }
                                        });
                                    }
                                })
                            }).catch(e => {
                                const lh = qs('.loaderholder',a.closest('.dLoad'));
                                if(lh) {
                                    lh.parentNode.removeChild(lh);
                                }
                            });
                        }
                    }
                } else {
                    lastHovered = {id:id,event:e};
                }
            }
        }
    }

    const setupCatHover = (nextul) => {
        const cul = qs('ul',nextul);
        cul.addEventListener('scroll', throttle(() => {
            if(nextul.offsetHeight < cul.scrollHeight) {
                nextul.classList.add('scrollable');
                if(cul.scrollTop > 0) {
                    nextul.classList.add('scrollableUp');
                } else {
                    nextul.classList.remove('scrollableUp');
                }
                if(cul.scrollTop + nextul.offsetHeight < cul.scrollHeight) {
                    nextul.classList.add('scrollableDown');
                } else {
                    nextul.classList.remove('scrollableDown');
                }
            } else {
                cul.classList.remove('scrollable');
            }
        },250));
        triggerEvent(cul,'scroll');

        const scrlup = qs('.scrlup',nextul);
        scrlup.addEventListener('click', () => {
            cul.scrollTo({top:cul.scrollTop - nextul.offsetHeight, behavior:'smooth'});
        });

        const scrldown = qs('.scrldn',nextul);
        scrldown.addEventListener('click', () => {
            cul.scrollTo({top:cul.scrollTop + nextul.offsetHeight, behavior:'smooth'});
        });
    }

    const renderCategoryMenus = (categories) => {
        fetch(`/api/nav/categories?${categories.length == 0?'':`root=${categories.map(c=>c.id).join(',')}`}&md=2`).then(res => res.json()).then(data => {
            if(categories.length == 0) {
                categoryData = data.categories;
                fe(categoryData, c => {
                    if(c.children && c.children.length > 0) {
                        categoryData = categoryData.concat(c.children);
                    }
                })
                const cat0 = qs('#cat0');
                cat0.innerHTML = `<div class="ul"><div class="scrlup"></div><ul>${catChildrenHTML({children:data.categories})}</ul><div class="scrldn"></div></div>`;
                setupCatNavLinks(cat0.children[0]);
            } else if(data.categories.length > 0) {
                fe(data.categories, c => {
                    fe(c.children, cc => {
                        const catDataIndex = categoryData.findIndex(d => d.id == cc.id);
                        if(catDataIndex > -1) {
                            categoryData[catDataIndex] = cc;
                        } else {
                            categoryData.push(cc);
                        }
                    });
                });
            }
        }).catch(e => {
            setTimeout(() => {
                renderCategoryMenus(categories);
            }, 30);
        });
    }

    const setupCatNavLinks = (tgt) => {
        const links = qa('a', tgt);
        fe(links, a => {
            let isTouched = false;
            a.addEventListener('mouseenter', overCat);
            a.addEventListener('click', overCat);
            a.addEventListener('touchstart', function(e) {
              isTouched = true;
            });
            a.addEventListener('click', (e) => {
                if((isTouched && e.target.classList.contains('hasChildren') && !e.target.classList.contains('clicked')) || hasScrolled) {
                    e.preventDefault();
                }
                e.target.classList.add('clicked');
                hasScrolled = false
            });
        });
        setupCatHover(tgt);
        let isDown = false;
        let startY;
        let scrollTop;
        let hasScrolled = false;
        let moved = false;

        const ul = qs('ul',tgt);
        ul.addEventListener('mousedown',e => {
            isDown = true;
            startY = e.pageY - ul.getBoundingClientRect().top;
            scrollTop = ul.scrollTop;
        });
        ul.addEventListener('mouseleave',e => {
            isDown = false;
        });
        ul.addEventListener('mouseup',e => {
            isDown = false;
            moved = false;
            ul.classList.remove('active');
            let newY = e.pageY - ul.getBoundingClientRect().top;
        });
        ul.addEventListener('mousemove',e => {
            if(!isDown) return;
            const y = e.pageY - ul.getBoundingClientRect().top;
            if((y < startY-5 || y > startY+5)) {
                e.preventDefault();
                const walk = (y - startY); //scroll-fast
                ul.scrollTop = scrollTop - walk; 
                hasScrolled = true;
                moved = true;
            }
        });
    }

    let gettingManufacturers = false;
    const renderManufacturerMenu = (container) => {
        if(container && !gettingManufacturers) {
            gettingManufacturers = true;
            fetch(`/api/nav/manufacturer`).then(res => res.json()).then(data => {
                const loader = qs('.loaderholder',container);
                if(loader) {
                    loader.parentNode.removeChild(loader);
                }

                let newcontainer = document.createElement('div');
                newcontainer.classList.add('b');
                const asseturl = data.assetbase;
                fe(data.manufacturers, (m,i) => {
                    let n = document.createElement('a');
                    n.href = '/' + m.url_key;
                    n.innerHTML = `<picture><img class="product_brand" src="${asseturl}${m.brand_logo_url}" alt="${m.manufacturer_name}" loading="lazy" /></picture>`;
                    newcontainer.appendChild(n);
                });
                container.insertBefore(newcontainer, qs('.btn',container));
            }).catch(e => {
                gettingManufacturers = false;
            });
        } else {
            const loader = qs('.loaderholder',container);
            if(loader) {
                loader.parentNode.removeChild(loader);
            }
        }
    }
    
    w.dynamicLoad = n => {
        const u = ds(n,'url');
        if(called.indexOf(u) == -1) {
            called.push(u);
            const thisloader = loader.cloneNode(true);
            n.prepend(thisloader);
            if(u.match(/^\d+$/)) {
                renderCategoryMenus([{id:u,node:n}]);
            } if(u.length == 0) {
                renderCategoryMenus([]);
            } else if(u == '/api/nav/manufacturer') {
                renderManufacturerMenu(n)
            } else {
                fetch(u)
                .then(res => res.text())
                .then(dText => {
                    fe(qa('.dLoad[data-url="' + u + '"]'),m => {
                        if(loader.parentNode) {
                            loader.parentNode.removeChild(thisloader);
                        }
                        const b = qs('.nostockicon',m);
                        if(b) {
                            m.removeChild(b);
                        }
                        if(u.indexOf('#') > -1) {
                            const pseudo = document.createElement('div');
                            pseudo.innerHTML = dText;
                            const psuedosection = qs(u.substring(u.indexOf('#'),u.length),pseudo);
                            if(psuedosection) {
                                m.innerHTML = psuedosection.innerHTML;
                            } else {
                                m.innerHTML = dText;
                            }
                        } else {
                            m.innerHTML = dText;
                        }
                        if(b) {
                            m.insertBefore(b, m.firstChild);
                        }
                    });
                }).catch(e => {
                    console.log(e);
                    let itemIndex = called.indexOf(u);
                    if(itemIndex > -1) {
                        called.splice(itemIndex,1);
                    }
                });
            }
        }
    }
    document.body.addEventListener('click', (e) => {
        if(e.target.nodeName !== "A" && !e.target.closest('a')) {
            let activeItem = qs('#navexpander li.active .drop');
            if(activeItem) {
                activeItem.closest('.active').classList.remove('active');
                activeItem.classList.remove('slideDown');
                activeItem.classList.add('slideUp'); 
                const removeActive = () => {
                    activeItem.classList.remove('slideUp');
                    activeItem.removeEventListener('animationend',removeActive);
                }
                activeItem.addEventListener('animationend',removeActive);
            }
            nav.classList.remove('on');
        }
    })

    const imageObserver = new IntersectionObserver((entries, observer) => {
      fe(entries, (entry, index) => {
        if (entry.isIntersecting) {
          w.dynamicLoad(entry.target);
        }
      });
    });

    fe(dloads, div => {
      imageObserver.observe(div);
    });

    if(!window.matchMedia(msm).matches) {
        window.addEventListener('load', () => {
            setTimeout(() => {
                let catids = [];
                fe(dloads, n => {
                    const u = ds(n,'url');
                    if(called.indexOf(u) == -1) {
                        if(u.match(/^\d+$/)) {
                            catids.push({id:u,node:n})
                            called.push(u);
                        } else if(u.length == 0) {
                            renderCategoryMenus([]);
                        } else if(u == '/api/nav/manufacturer') {
                            renderManufacturerMenu(n)
                        } else {
                            w.dynamicLoad(n);
                        }
                    }
                });
                if(catids.length > 0) {
                    renderCategoryMenus(catids);
                }
            }, 3000);
        });
    }

    //Scroll events for sticky features
    sct = qs('#sctop');
    const ft = qs('.footer');


    const throttledScroll = () => {
        w.st = w.scrollY;
        if(w.st < 100) {
            if(sct.classList.contains("nottop")) {
                sct.classList.remove("nottop");
            }
        } else {
            sct.classList.add("nottop"); 
            w.body.classList.add("nottop");
            w.checksct();
            if(sct.getBoundingClientRect().top + 24 > ft.getBoundingClientRect().top) {
                sct.classList.add('overFooter');
            } else {
                sct.classList.remove('overFooter')
            }
        }
    }
    window.addEventListener('scroll', throttle(throttledScroll,100));

    //Information popups
    ipopSetup('body');

    if(qs('.jspopup')) {
        const jpl = qa('.jspopuplink'); 
        fe(jpl,a => {
            a.addEventListener('click', (e) => {
                let t = a.href;
                t = t.substring(t.indexOf('#'),t.length);
                if(ds(a,'popwidth')) {
                    popDivContent(t,ds(a,'popwidth'));
                } else {
                    popDivContent(t);
                }
                if(e) {
                    e.preventDefault();
                }
                return false;
            });
        });
    }

    const newsbtns = qa('.newsbtn');
    if(newsbtns.length > 0) {
        fe(newsbtns,(n) => { 
            n.addEventListener('click', (e) => {
                cabox.init(null, {content:'<h2>Newsletter signup</h2><p>Keep up to date with our latest offers and competitions</p><form class="js-cm-form" id="subForm" action="https://www.createsend.com/t/subscribeerror?description=" method="post" data-id="A61C50BEC994754B1D79C5819EC1255CFCC0FDA5D479B98F2DB257A191DB74EA80DF57EA2D4768500D8A2919073D5E6D0EB96FF5549C1E7E4931A931EB9EAFD3"><div><div class="form-field required-field"><label>Name </label><input aria-label="Name" id="fieldName" maxlength="200" name="cm-name"></div><div class="form-field required-field"><label>Email </label><input autocomplete="Email" aria-label="Email" class="js-cm-email-input qa-input-email" id="fieldEmail" maxlength="200" name="cm-gtudid-gtudid" required="" type="email"></div></div><button class="btn" type="submit">Subscribe</button></form>',onComplete:() => {loadJS('https://js.createsend1.com/javascript/copypastesubscribeformlogic.js',document.head);}});
                e.preventDefault();
                return false;
            })
        })
    }

    const loadDeferredStyles = () => {
        const addStylesNode = qs("#deferred-styles");
        var replacement = document.createElement("div");
        replacement.innerHTML = addStylesNode.textContent;
        while(replacement.childNodes.length > 0) {
            document.head.appendChild(replacement.childNodes[0]);
        };
        addStylesNode.parentElement.removeChild(addStylesNode);
    };
    if (idl) idl(function() { window.setTimeout(loadDeferredStyles, 10); });
    else window.addEventListener('load', loadDeferredStyles);

    document.body.addEventListener('keyup', e => {
        if(document.activeElement === document.body && e.keyCode === 191) {
            qs('#search').focus();
        }
    });

    let loadingDelayed = true;
    const stopDelay = () => {
        if(loadingDelayed) {
            const delays = qa('.delayload');
            fe(delays, (n) => {
                n.classList.remove('delayload');
            })
            loadingDelayed = false;
        }
    }

    const mouseScroll = (gallery) => {
        const slider = qs('.gallery_holder',gallery);
        let isDown = false;
        let hasMoved = false;
        let startX;
        let lastX;
        let lastMove;
        let scrollLeft;
        let screentouched = false;

        window.addEventListener('touchstart', function() {
          screentouched = true;
        }, {passive: true});

        slider.addEventListener('mousedown',e => {
          if(!screentouched && e.button === 0) {
            isDown = true;
            hasMoved = false;
            startX = lastX = e.pageX - slider.getBoundingClientRect().left;
            lastMove = 0;
            scrollLeft = slider.scrollLeft;
          }
        });
        slider.addEventListener('mouseleave',e => {
          if(!screentouched && isDown) {
            endDrag(e)
          }
        });
        slider.addEventListener('mouseup',e => {
          if(hasMoved) {
            e.preventDefault();
            return false;
          }
        });
        slider.addEventListener('mousemove',e => {
          if(!screentouched) {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.getBoundingClientRect().left;
            const walk = x - startX; //scroll-fast
            if(Math.abs(walk) > 10) {
                if(!hasMoved) {
                    hasMoved = true;
                    gallery.classList.add('dragging');
                    gallery.classList.add('adragging');
                } else {
                    slider.scrollLeft = scrollLeft - walk;
                }
                const newX = e.pageX - slider.getBoundingClientRect().left;
                if(newX != lastX) {
                    lastMove = newX - lastX;
                    lastX = newX;
                }
            }
          }
        });
        slider.addEventListener('click',e => {
            if(!screentouched && hasMoved) {
                e.preventDefault();
                endDrag(e);
                return false;
            }
        });
        function endDrag(e) {
            isDown = false; 
            if(hasMoved) {
                hasMoved = false;
                gallery.classList.remove('adragging');
                const w = gallery.offsetWidth;
                if(lastMove < 0) {
                    slider.scrollLeft = (Math.floor(slider.scrollLeft / w) * w) + w;
                } else if(lastMove > 0) {
                    slider.scrollLeft = (Math.ceil(slider.scrollLeft / w) * w) - w;
                }
                setTimeout(() => {
                    gallery.classList.remove('dragging');    
                },500);
            }
        }
    }
    const scrollButtons = a => { 
        if(a) { 
            const apos = a.getBoundingClientRect();
            const ppos = a.parentNode.getBoundingClientRect();
            if(apos.right > ppos.right) { 
                a.parentNode.scrollLeft += (apos.right - ppos.right);
            } else if(apos.left < ppos.left) { 
                a.parentNode.scrollLeft -= (ppos.left - apos.left);
            }
        }
    };
    const galleries = qa('.gallery');

    fe(galleries, (gallery) => {
        const ob = qs('.offer-banners-buttons',gallery.parentNode);
        const slides = qa('.galleryItem');
        const galleryItems = qs('.itemButtons');
        scrollButtons(qs('.activeButton',gallery));
        mouseScroll(gallery);


        gallery.addEventListener('mouseenter', stopDelay);
        gallery.addEventListener('touchstart', stopDelay, {passive: true});
        if(galleryItems) {
            galleryItems.addEventListener('touchstart', stopDelay, {passive: true});
        }
        
        const setActiveButton = (ib) => {
            const siblings = ib.parentNode.children;
            fe(siblings, s => {
                if(s.classList.contains('activeButton') && s != ib) {
                    s.classList.remove('activeButton');
                }
            });
            ib.classList.add('activeButton');
        }
        if(galleryItems) {
            fe(slides, (n,i) => {
                const ib = galleryItems.children[i];
                ib.addEventListener('click', (ev) => {
                    let ppos = n.parentNode.parentNode.getBoundingClientRect();
                    let npos = n.getBoundingClientRect();
                    n.parentNode.parentNode.scrollLeft += npos.left - ppos.left;
                    ev.preventDefault();
                });

                const imgs = qa('img',n);
                if(imgs.length > 0){
                    fe(imgs, img => {
                        if(ds(img,'video') && getWWidth() > 767) {
                            const v = document.createElement('div');
                            v.classList.add('v');
                            const vs = document.createElement('span');
                            v.appendChild(vs);
                            const vid = document.createElement('video');
                            vid.muted = true;
                            if(i==0) {
                                vid.autoplay = true;
                            } else {
                                vid.preload = "none";
                            }
                            if(ds(img,'video-loop')) {
                                vid.loop = true;
                            }
                            const vidsrc = document.createElement('source');
                            vidsrc.src = ds(img,'video');
                            const vidcap = document.createElement('track');
                            vidcap.kind = 'captions';
                            vidcap.srclang = 'en';
                            vidcap.src = ds(img,'vidcap');
                            vid.appendChild(vidsrc);
                            vid.appendChild(vidcap);
                            vs.appendChild(vid);
                            img.parentNode.insertBefore(v,img);
                        }
                        if(ds(img,'label')) {
                            n.setAttribute('aria-label',ds(img,'label'));
                        }
                    });
                }
                if(i == 0) {
                    ib.classList.add('activeButton');
                    setTimeout(() => {
                        if(w.bannerViewEvent) {
                            w.bannerViewEvent(n);
                        }
                    },0);
                }
            });
            /*if(ob) {
                ob.appendChild(galleryItems);
            } else {
                gallery.appendChild(galleryItems);
            }*/
            const gscroll = qs('.gallery_holder',gallery);
            const endscroll = () => {
                if(w.bannerViewEvent) {
                    w.bannerViewEvent(activeBanner);
                }
            }
            let activeBanner = undefined;
            gscroll.addEventListener('scroll',() => {
                let smallest, smallestNode = undefined;
                let gpos = gallery.getBoundingClientRect();
                fe(slides, (c,i) => {
                    if(typeof smallest === 'undefined' || Math.abs(c.getBoundingClientRect().left - gpos.left) < smallest) {
                        activeBanner = c;
                        smallest = Math.abs(c.getBoundingClientRect().left - gpos.left);
                        smallestNode = galleryItems.children[i];
                    }
                });
                if(smallestNode) {
                    setActiveButton(smallestNode);
                }
                clearTimeout(window.scrollEndTimer);
                window.scrollEndTimer = setTimeout(endscroll, 100);
            }, {passive: true});
        } else {
            if(w.bannerViewEvent) {
                w.bannerViewEvent(qs('a',slides[0]));
            }
        }
    });

    w.setupIncrementors('');
    
    /* Christmas snow
    let xmas = qs('img.xmas_logo');
    if(xmas) {
        let xmastimeout;
        xmas.addEventListener('click', (e) => {
            if(xmastimeout) {
                clearTimeout(xmastimeout);
            }
            xmastimeout = setTimeout(() => {
                location.href = '/'; 
            },500);
            e.preventDefault();
            e.stopPropagation();
            return false;
        });
        xmas.addEventListener('dblclick', (e) => {
            if(xmastimeout) {
                clearTimeout(xmastimeout);
            }
            let snow = qs('#snow');
            if(snow) {
                document.body.removeChild(snow);
            } else {
                loadJS('behaviour/snow-bundle.js');
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        })
    }*/

    // Triggering custom event for when basic script page setup complete
    setTimeout(() => {
        const srevent = document.createEvent("Event");
        srevent.initEvent("scriptReady", true, true);
        srevent.eventName = "scriptReady"; 
        document.dispatchEvent(srevent);
    },0);
};


let previousHeights = 0;
const stkyobshandler = (entries, observer) => {
    const bodystyles = document.body.currentStyle || window.getComputedStyle(document.body);
    const bodpadtop = Number(bodystyles.paddingTop.replace('px','')) || 0;
    if(bodpadtop) {
        previousHeights += bodpadtop;
    }
    fe(entries, (entry, index) => {
        const cHeight = entry.target.children[0].offsetHeight;
        if(entry.boundingClientRect.y <= previousHeights) {
            if(!entry.target.classList.contains("stuk")) {
                previousHeights += cHeight;
            }
            entry.target.classList.add("stuk");
        } else {
            if(entry.target.classList.contains("stuk")) {
                previousHeights -= cHeight;
            }
            entry.target.classList.remove("stuk");
            entry.target.style.zIndex = '';
            entry.target.style.top = '';
            if(entry.boundingClientRect.y > -cHeight) {
                entry.target.children[0].style.transform = '';
                Object.assign(entry.target.children[0].style,{
                    transform:'',
                    transition:''
                });
            }
        }
        w.checksct();
    });
}

// Intersection observer handlers
const bottomstkyobsHandler = (entries, observer) => {
    fe(entries, (entry, index) => {
        const s = qs('.stky',entry.target);
        if(entry.boundingClientRect.y < (-entry.target.offsetHeight+1)) {
            if(s.offsetHeight == 0) {
                s.classList.remove("stuk");
                s.offsetHeight;
            }
            s.parentNode.style.minHeight = s.offsetHeight + 'px';
            s.classList.add("stuk");
        } else {
            s.classList.remove("stuk");
            s.style.zIndex = '';
            s.children[0].style.transform = '';
            Object.assign(s.children[0].style,{
                transform:'',
                transition:''
            });
            s.parentNode.style.minHeight = '';
        }
        w.checksct();
    });
}


//Top level nav links e.g Categories, Brands, Need Help
const closenl = e => {
    const active = qs('.navlink.active');
    active.click();
    e.target.classList.remove('active');
}
const nlclick = e => {
    let a = e.target;
    if(a.nodeName != 'A') {
        a = a.closest('a');
    }
    const ahref = a.getAttribute('href');
    const targetid = ahref.substring(ahref.indexOf('#'), ahref.length);
    const par = a.closest('.transnav,body');
    const tgt = qs(targetid);
    fe(qa('.navlink.active'), a => {
        a.classList.remove('active');
    });
    a.classList.remove('active');
    const tgts = tgt.currentStyle || window.getComputedStyle(tgt);
    const backing = qs('.nebacking');
    if(tgts.display == 'none') {
        a.classList.add('active');
        backing.removeEventListener('click',closenl);
        backing.addEventListener('click',closenl);
        backing.classList.add('active');
        if(a.parentNode.classList.contains('shopoptions')) {
            const oldtgts = ap.filter.call(qa('.shopoptions > div, .navexpand > div'), b => {
                return b.offsetHeight > 0 && !b.classList.contains('navlink') && !b.classList.contains('btn'); 
            });
            if(oldtgts.length > 0) {
                fe(oldtgts, oldtgt => {
                    slideUp(oldtgt);
                })
                slideDown(tgt);
                
            } else {
                slideDown(tgt);
            }
        } else {
            slideDown(tgt);
        }
        const childDload = qs('.dLoad',tgt); 
        if(childDload) {
            w.dynamicLoad(childDload);
        }
    } else {
        a.classList.remove('active');
        slideUp(tgt);
        backing.removeEventListener('click',closenl);
        backing.classList.remove('active');
    }
    e.preventDefault();
}

const setupnls = a => {
    const ahref = a.getAttribute('href');
    const targetid = ahref.substring(ahref.indexOf('#'), ahref.length);
    const par = a.closest('.transnav,body');
    const tgt = qs(targetid);
    if(tgt) {
        tgt.classList.remove('jshidden');
        if(!a.classList.contains('active')) {
            tgt.style.display = 'none'; 
        }
        if(par.classList.contains('transnav')) {
            a.insertAdjacentElement('afterend',tgt);
        } else {
            qs('.navexpand').appendChild(tgt);
        }
        a.removeEventListener('click', nlclick);
        a.addEventListener('click', nlclick);
    }
}

// Array of  functions to call when cabox is opened
if(typeof w.caboxPoppedFunctions != 'object') {
    w.caboxPoppedFunctions = [];
}
const caboxpc = () => {
    const pcn = qs('#postcode',qs('#cabox'));
    pcn.value = pcn.value.replace(/[^a-zA-Z0-9 ]*/gi,'');
}
w.caboxPoppedFunctions.push(
    () => {
        const cabn = qs('#cabox');
        const pcf = qs('.postcodeform', cabn);
        if(pcf) {
            pcf.removeEventListener('submit',caboxpc);
            pcf.addEventListener('submit',caboxpc);
        }
        const pgio = qs('.pgitem .offer',cabn);
        if(pgio) {
            pgio.removeEventListener('submit',vatSwitcher);
            pgio.addEventListener('submit',vatSwitcher);
        }
        const iframeReplace = qs('.iframereplace',cabn);
        if(iframeReplace) {
            iframeReplace.addEventListener('click', e => {
                e.preventDefault();
                const iframeNode = document.createElement('iframe');
                iframeNode.setAttribute('allow',"autoplay");
                iframeNode.setAttribute('src',e.target.getAttribute('href'));
                const frameHolder = document.createElement('div');
                frameHolder.id = 'caframeholder';
                frameHolder.appendChild(iframeNode);
                iframeReplace.parentNode.insertBefore(frameHolder,iframeReplace);
                iframeReplace.parentNode.removeChild(iframeReplace);
            })
        }
        const video = qs('video',cabn);
        if(video) {
            video.removeAttribute('preload');
        }
    }
);

w.popDivContent = (t, maxwidth) => {
    if(t.indexOf('#') == 0 && qs(t)) {
        const c = qs(t).cloneNode(true);
        c.classList.remove('jspopup');
        const o = {
            content:c,
            onComplete:() => {
                for(let i = 0;i < w.caboxPoppedFunctions.length;i++) {
                    w.caboxPoppedFunctions[i]();
                }
            }
        }
        if(maxwidth) {
            o.maxwidth = maxwidth;
        }
        cabox.init(null,o);
    }
}

//Utility function to prevent calls being called to often
w.throttle = (fn, threshhold, scope, ...args) => {
  threshhold || (threshhold = 250);
  let last,
      deferTimer;
  return () => {
    const context = scope || this;

    const now = +new Date;
    if (last && now < last + threshhold) {
      // hold on to it 
      clearTimeout(deferTimer);
      deferTimer = setTimeout(() => {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

//Short hand to trigger vat switches, cookie system
const vatSwitch = (i,o) => {
    const b = document.body;
    if(b.classList.contains(o+'vat') && !b.classList.contains(i+'vatin')) {
        b.className = b.className.replace(' '+o+'vatin', '') + ' '+i+'vatin';

        setTimeout(() => {
            if(b.className.indexOf(i+'vatin') > -1) {
                if(dataLayer) {
                    dataLayer.push({event:'vat_switch', value:i });
                }
                b.className = `${b.className.replace(new RegExp(' ?(ex|in)cvat(in)?','g'),'')} ${o}vatin ${i}vat`;
                setTimeout(() => {
                    b.classList.remove(o+'vatin');
                    if(typeof filtersRender == 'function') {
                        filtersRender();
                    }
                },5);
            }
        },300);
        document.cookie = `cookievat=${i}vat;path=/;samesite=lax`;
    }
}
const activateIncVat = () => {
    vatSwitch('inc','exc');
}
const activateExcVat = () => {
    vatSwitch('exc','inc');
}

const cookievat = document.cookie.match(/cookievat=([^;]+)/);
w.vatSwitcher = () => {
    const b = document.body;
    if(b.className.indexOf('incvat') > -1) {
        activateExcVat();
    } else {
        activateIncVat();
    }
}

// Pop out information on hover
w.ipopSetup = sel => {
    const cont = qs(sel);
    const ipops = qa('.ipop',cont);
    if(ipops.length > 0) {
        let ipop = qs('.ipopout',document.body);
        if(!ipop) {
            ipop = document.createElement('div');
            ipop.className = 'ipopout';
            ipop.innerHTML = '<div id="ipopcontent"></div><span class="icon poparrow"></span>';
            document.body.appendChild(ipop);
        }
        const ipopcontent = ipop.children[0];
        fe(ipops,ip => {
            ds(ip,'title', ip.title);
            ip.title = '';
            ip.addEventListener('mouseenter', () => {
                const pos = ip.getBoundingClientRect();
                st = window.pageYOffset;
                
                if(ip.classList.contains('vert')) {
                    if(!ipop.classList.contains('vert')) {
                        ipop.classList.add('vert');
                    }
                    ipopcontent.innerHTML = ds(ip,'title');
                    Object.assign(ipop.style, {
                        top: `${((pos.top + st) + ip.offsetHeight + 13)}px`,
                        left: `${(pos.left + (ip.offsetWidth/2))}px`
                    })
                } else {
                    ipop.classList.remove('vert');
                    ipopcontent.innerHTML = ds(ip,'title');
                    Object.assign(ipop.style, {
                        top: `${((pos.top + st) + (ip.offsetHeight/2))}px`,
                        left: `${(pos.left + ip.offsetWidth + 13)}px`
                    });
                }
                fadeIn(ipop);
            });
            ip.addEventListener('mouseout', () => {
                fadeOut(ipop);
            });
        });
    }
}

// Analytics and GA4 information
w.gatrackclick = (a, cat, lab, val, e) => {
    if(typeof gapvc == 'function') {
	   gapvc();
    }
    if(dataLayer) {
        dataLayer.push({
            'event': 'click',
            'event_category': cat,
            'event_label': lab,
            'value': val,
            'eventCallback' : function() {
                if(a.href) {
                    location.href = a.href;
                } else if(a.type == 'submit') {
                    let frm = a.closest('form');
                    frm.submit();
                }
            }
        });
    }
    if(typeof google_tag_manager === 'object' && e) {
        e.stopPropagation();
        e.preventDefault();
        return false;
    }
	return true;
}
let prodadded = false;

w.ga4a2b = () => {
    if(window.proddata) {
        const proddata = window.proddata;
        const q = qs('#quantity');
        proddata.quantity = q.value;
        const mpn = qs('span[itemprop="mpn"]');
        if(mpn) {
            proddata.varient = mpn.textContent;
        }
        proddata.price= ds(q,'price');

        dataLayer.push({ ecommerce: null });
        const item = {
          'item_name': proddata.name,
          'item_id': proddata.id,
          'price': proddata.price,
          'item_brand': proddata.brand,
          'item_category': proddata.category,
          'quantity': proddata.quantity
        }
        if(lastList != null && typeof lastList != 'undefined') {
            item.item_list_name = lastList;
        }
        if(lastPromo != null && typeof lastPromo != 'undefined') {
            item.promotion_name = lastPromo;
        }
        dataLayer.push({
            'event': 'add_to_cart',
            'ecommerce': {
              'items': [item]
            }
        });
        const sa = JSON.parse(localStorage.getItem("savedattr") || '{}');
        if(item.item_list_name || item.promotion_name) {
            const o = {};
            if(item.item_list_name) {
                o.list = item.item_list_name;
            }
            if(item.promotion_name) {
                o.promo = item.promotion_name;
            }
            sa[proddata.id] = o;
            localStorage.setItem("savedattr", JSON.stringify(sa));
        }
    }
}

w.gaAddToBasket = f => {
 if(!prodadded && window.proddata) {
    const proddata = window.proddata;
    const q = qs('#quantity');
    proddata.quantity = q.value;
    const mpn = qs('span[itemprop="mpn"]');
    if(mpn) {
        proddata.varient = mpn.textContent;
    }
    proddata.price= ds(q,'price');
    if(typeof gapvc == 'function') {
       gapvc();
    }

    dataLayer.push({ ecommerce: null });
    const item = {
      'item_name': proddata.name,
      'item_id': proddata.id,
      'price': proddata.price,
      'item_brand': proddata.brand,
      'item_category': proddata.category,
      'quantity': proddata.quantity
    }
    if(lastList != null && typeof lastList != 'undefined') {
        item.item_list_name = lastList;
    }
    if(lastPromo != null && typeof lastPromo != 'undefined') {
        item.promotion_name = lastPromo;
    }
    dataLayer.push({
        'event': 'add_to_cart',
        'ecommerce': {
          'items': [item]
        }
    });

    return true;
 }
}

// Get total width of children (including margin right)
const getChildenPerWidth = a => {
    let total = 0;
    fe(a, c => {
        if(!c.classList.contains('paddingadd')) {
            const style = c.currentStyle || window.getComputedStyle(c);
            const hspace = Number(style.marginRight.replace('px',''));
            if(c.parentNode.parentNode.offsetWidth >= total + c.offsetWidth) {
                total += c.offsetWidth + hspace;
            }
        }
    });
    return total;
}

// Utility class for currency display
w.currencyPad = (num, nocommas) => {
    let str = String(num);
    if(str.indexOf('.')  < 0) {
        str = str + ".00";
    } else {
        str = String(Math.round(num*100)/100);
        if(str.indexOf('.') < 0) {
            str = str + ".00";
        } else if(str.indexOf('.') == str.length - 2) {
            str = str + "0";
        }
    }
    if(nocommas) {
        return str;
    } else {
        return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}

window.userhash = true;
window.scripthash = false;

//Crossbrowser trigger event function
w.triggerEvent = (element, etype) => {
    const evt = document.createEvent("Event");
    evt.initEvent(etype, true, true);
    element.dispatchEvent(evt);
}

let notfirstPage = true;
if(localStorage) {
    notfirstPage = localStorage.getItem('notfirstPage');
    if(notfirstPage) {
        document.body.classList.add('notfirst');
    }
}

// Trigger on load (with lazy loading images this happens quickly) for thurd party scripts
const pageLoadComplete = () => {
    const loadFunction = () => {
        if(localStorage) {
            if(!notfirstPage) {
                try {
                    localStorage.setItem('notfirstPage', true);
                } catch(e) {
                    notfirstPage = true;
                }
            }
        }

        if(sct) {
    	   sct.classList.add('loaded');
        }

        triggerEvent(window,'resize');
        if(notfirstPage) {
            activeGTM();
            setTimeout(() => {
                optionalFunc();
                funcCook();
            },3000);
        } else {
            setTimeout(() => {
                optionalFunc();
                funcCook();
                activeGTM();
            },3500);
        }
    } 
    if (idl) idl(function() { window.setTimeout(loadFunction, 10); });
    else loadFunction()
}

let optactive = 0;
const optionalFunc = () => {
    if(cprefs[2] == '1' && !optactive) {
        optactive = 1;
        /*window.$crisp=[];window.CRISP_WEBSITE_ID="1acb76fe-a3cb-4aa5-9d0e-775f9777d6a1";
        $crisp.push(["on", "session:loaded", () => {qs('.cc-1oun').setAttribute('aria-label','Chat with our sales team')} ]);
        loadJS('https://client.crisp.chat/l.js');*/
        if(!document.referrer.includes('catering-appliance')&&!document.referrer.includes('localhost')){document.documentElement.classList.add('first')}

        if(typeof gcrmi != 'undefined') {
            loadJS('https://apis.google.com/js/platform.js', () => {
                const ratingBadgeContainer = document.createElement("div");
                document.body.appendChild(ratingBadgeContainer);
                window.gapi.load('ratingbadge', () => {
                    window.gapi.ratingbadge.render(ratingBadgeContainer, {"merchant_id": gcrmi,"position": "TOP_LEFT"});
                    qs('#___ratingbadge_0').children[0].title = 'Google Shopping Customer Reviews';
                });
            });
        }
    }
}
let funcactive = 0;
const funcCook = () => {
    if(!funcactive && cprefs[1] == '1') {
        const fb = document.createElement('img');
        fb.style.display = 'block';
        fb.style.overflow = 'hidden';
        fb.style.height = '0px';
        fb.src = "https://www.facebook.com/tr?id=324047364907932&ev=PageView&noscript=1";
        fb.alt = "";
        document.body.appendChild(fb);
    }
    if(location.href.indexOf('checkout') == -1 && location.href.indexOf('?') == -1) {
        loadJS(asc+'/shop/vendor/qrcode.min.js',() => {
            const footqr = document.createElement('div');
            footqr.classList.add('printonly');
            var qr = qrcode(0, 'L')
            qr.addData(location.href);
            qr.size
            qr.make();
            footqr.innerHTML = qr.createSvgTag({scalable:true});
            qs('svg',footqr).style.width = '200px';
            qs('svg',footqr).style.height = '200px';
            qs('.footer .cols').appendChild(footqr);

        });
    }
}

// Horizontal scrollers with buttons
w.setupHScrollers = hshs => {
    let tstartX, tstartY, tX, tY;
    let ascrolling = false;
    fe(hshs, hsh => {
        const hs = qs('.hscroller',hsh);
        const hsw = qs('.hscrollerwidth',hs);

        const getHSWidth = () => {
            let width = hs.offsetWidth;
            const hsstyle = hs.currentStyle || window.getComputedStyle(hs);
            const hswstyle = hsw.currentStyle || window.getComputedStyle(hsw);
            if(hsstyle.paddingLeft) {
                width -= Number(hsstyle.paddingLeft.replace('px',''));
            }
            if(hsstyle.paddingRight) {
                width -= Number(hsstyle.paddingRight.replace('px',''));
            }
            if(hswstyle.gap) {
                width += Number(hswstyle.gap.replace('px',''));
            }
            return width;
        }
        let lb = qs('.left_arrow', hsh);
        if(!lb) {
            lb = document.createElement('div');
            lb.className = 'left_arrow disabled';
            lb.innerHTML = '<div><span class="icon arrowleft"></span></div>';
            hsh.insertBefore(lb,hs);
        }
        lb.addEventListener('click', () => {
            if(!lb.classList.contains('disabled') && !ascrolling) {
                if(hsw.children.length > 0) {
                    ascrolling = true;
                    let hscollerwidth = getHSWidth()
                    let target = (hs.scrollLeft - hscollerwidth);
                    if(target < 0) {
                        target = 0; 
                    }
                    goToScrollLeft(hs, target);
                    setTimeout(() => {
                         ascrolling = false;
                    },500);
                }
            }
        });
        let rb = qs('.right_arrow', hsh);
        if(!rb) {
            rb = document.createElement('div');
            rb.className = 'right_arrow';
            rb.innerHTML = '<div><span class="icon arrowright"></span></div>';
            hsh.insertBefore(rb,hs);
        }
        rb.addEventListener('click',() => {
            if(!rb.classList.contains('disabled') && !ascrolling) {
                if(hsw.children.length > 0) {
                    ascrolling = true;
                    let hscollerwidth = getHSWidth()
                    let target = (hs.scrollLeft + hscollerwidth);
                    if(target >= hs.scrollWidth - hs.offsetWidth) {
                        target = hs.scrollWidth - hs.offsetWidth - 1; 
                    }
                    goToScrollLeft(hs, target);
                    setTimeout(() => {
                         ascrolling = false;
                    },500);
                }

            }
        });
        let scrollTimeout;
        const scrolledhs = () => {
            const sl = hs.scrollLeft;
            const lbd = lb.classList.contains('disabled');
            const rbd = rb.classList.contains('disabled');
            if(sl == 0 && !lbd) {
                lb.classList.add('disabled');
            } else if(sl != 0 && lbd) {
                lb.classList.remove('disabled');
            }
            if(sl >= hs.scrollWidth - hs.offsetWidth - 10 && !rbd) {
                rb.classList.add('disabled');
            } else if(sl < hs.scrollWidth - hs.offsetWidth - 10 && rbd) {
                rb.classList.remove('disabled');
            }
        }
        hs.addEventListener('scroll',throttle(scrolledhs));
        window.addEventListener('resize',throttle(scrolledhs,250));

        const observer = new IntersectionObserver((entries) => {
            scrolledhs();
            observer.disconnect();
        });
        observer.observe(hs);
    });
}

// Search autocomplete
const initAutoSearch = element => {

    const search = element;

    let scontroller;
    search.setAttribute("autocomplete", "off");

    const positionAutoSearch = () => {
        if(output.style.display != 'none') {
            const outputPosition = search.getBoundingClientRect();
            const parentPosition = search.closest('.stky > div').getBoundingClientRect();
            output.style.left = outputPosition.left + "px";
            output.style.top = (outputPosition.bottom - parentPosition.top - (search.offsetHeight/2)) + "px";
            output.style.width = (search.offsetWidth-2) + "px";
            searchoutput.style.maxHeight = (window.innerHeight - outputPosition.bottom + st - 20) + "px";
        }
    }

    const hide = () => {
        search.classList.remove('active');
        output.style.display = 'none';
        search.classList.remove('completing');
    };

    const moveKeySelect = (direction, output) => {
        const activeClassName = 'keyselect';
        const items = Array.from(qa('.item', output));
        if (items.length === 0) {return;}
        const activeList = items.map((element, index) => { 
            return element.classList.contains(activeClassName) ? index : null; 
        }).filter(index => {return null !== index;});
        activeList.forEach(index => {items[index].classList.remove(activeClassName);});
        const active = items[Math.min(Math.max(0, (activeList.length > 0 ? activeList[0] : -1) + direction), items.length - 1)];
        active.classList.add(activeClassName);
        active.scrollIntoView({block: 'end'});
    };

    const output = document.createElement("div");
    output.className = "search-autocomplete default";
    output.style.display = "none";
    output.style.position = "absolute";

    const searchoutput = document.createElement("div");
    searchoutput.className = "search-autocomplete-holder";
    output.appendChild(searchoutput);

    search.parentNode.parentNode.parentNode.appendChild(output);

    output.addEventListener('focusout', (event) => {
        if(scontroller) {
            scontroller.abort('Operation cancelled by the user');
        }
        if (!event.target || !output.contains(event.target)) {
            hide();
        }
    });

    let lastSearchQuery;

    let timeout = null;
    search.addEventListener('keydown', e => {

        const charCode = (typeof e.which == 'number') ? e.which : e.keyCode;

        if(qa('.item',output).length > 0) {
            
            switch(charCode) {
                case 38:
                    e.preventDefault();
                    moveKeySelect(-1, output);
                    return false;
                case 40:
                    e.preventDefault();
                    moveKeySelect(1, output);
                    return false;
                case 13:
                    const ks = qs('.item.keyselect', output);
                    if(ks) {
                        e.preventDefault();
                        const a = qs('a', ks);
                        if (a) {
                            location.href = a.getAttribute('href');
                        }
                        return false;
                    }
                    break;
                case 27:
                    e.preventDefault();
                    lastSearchQuery = null;
                    output.innerHTML = '';
                    hide();
                    return false;
                case 13:
                    gtmPush({
                        'event': 'siteSearch',
                        'searchTerm': search.value
                    });
            }
        }

        if(timeout) clearTimeout(timeout);
        timeout = setTimeout(lookup, 400);
    });

    search.addEventListener('focus', () => {
        search.classList.add('active');
        if (lastSearchQuery) {
            output.style.display = 'block';
            search.classList.add('completing');
            positionAutoSearch();
        } else if(search.value.length > 0) {
            lookup();
        }
    });

    window.document.addEventListener('click', (e) => {
        if(search.classList.contains('active') && !output.contains(e.target) && e.target != search) {
            hide(); 
        }
    })

    window.addEventListener('resize', throttle(positionAutoSearch,250));
    
    let lastViewed = "default";
    const lookup = () => {
        
        if(document.activeElement == search) {
            timeout = null;
            output.style.display = 'block';
            search.classList.add('completing');

            positionAutoSearch();
            if(scontroller) {
                scontroller.abort('Operation cancelled by the user');
            }
            scontroller = new AbortController();
            const searchQuery = search.value;
            if (searchQuery.length === 0) {
                hide();
                return;
            }
            if (searchQuery === lastSearchQuery) {
                return;
            }

            fetch(`/search?q=${encodeURIComponent(searchQuery)}&chr=0&auto=1`,{ signal:scontroller.signal })
            .then(res => res.text())
            .then(actext => {
                lastSearchQuery = searchQuery;
                if(actext.indexOf('#'+lastViewed) == -1) {
                    output.classList.remove(lastViewed);
                    output.classList.add('default');
                }
                searchoutput.innerHTML = actext;
                fe(qa('.tab',output), a => {
                     a.addEventListener('click', (e) => {
                        const tgt = a.href.substring(a.href.indexOf('#')+1, a.href.length);
                        output.classList.remove(lastViewed);
                        output.classList.add(tgt);
                        lastViewed = tgt;
                        e.preventDefault();
                     });
                });
                fe(qa('.padding a',output), a => {
                    a.addEventListener('click', (e) => {
                        localStorage?localStorage.setItem('lastList','Search AutoComplete'):null;
                        gtmPush({
                            'event': 'siteSearch',
                            'searchTerm': search.value
                        });
                    });
                    a.addEventListener('keydown', e => {
                         const charCode = (typeof e.which == 'number') ? e.which : e.keyCode;
                         if(charCode == 27) {
                            search.focus();
                         }
                    })
                });
            }).catch(e => {
                console.log(e);
            });
        }
    }
}

// Utility to get window width of page without triggering reflow unless needed
w.getWWidth = force => {
    if(lastwwidth == 0 || force) {
        let w = window, a = 'inner';
        if (!('innerWidth' in window )) {
            a = 'client';
            w = document.documentElement || document.body;
        }
        return w[a+'Width'];
    } else {
        return lastwwidth;
    }
}

let lastwwidth = 0;
let viewMode = '';

// Mobile only expander action
const mobileHeadClick = e => {
    let h = e.target;
    if(!h.classList.contains('mobile_expand_head')) { 
        h = h.parentNode;
    }
    const vissib = qs('.mobile_expand_body', h.parentNode)
    if(vissib.offsetHeight > 0) {
        h.classList.remove('active');
        slideUp(vissib);
    } else {
        h.classList.add('active');
        slideDown(vissib);
    }
}

// Expanding filter display
w.filterHeadClick = e => {
    let f = e.target;
    if(!f.classList.contains('filter_head')) {
        f = f.closest('.filter_head');
    }
    if(f.classList.contains('active')) {
        f.classList.remove('active');
        slideUp(f.nextElementSibling);
    } else {
        f.classList.add('active');
        slideDown(f.nextElementSibling);
        setTimeout(() => {
            let b = f.nextElementSibling;
            let rect = b.getBoundingClientRect();
            if(rect.bottom > 0) {
                b.scrollIntoView({behavior:'smooth',block:'nearest'});
            }
        },300);
    }
}

//Master Page Resize Function
window.compareset = false;
let filterNode;

const initMobile = () => {
    const wwidth = getWWidth(true);
    const m = qs('#nav');
    let tnav = qs('#transnav0');
    const ne = qs('#navexpander');
    if(wwidth != lastwwidth) {
        if(window.matchMedia(msm).matches) {
            if(viewMode != 'mobile' && m) {
                if(!qs('.menu-toggle',m)) {
                    qs('.stky').after(qs('#nav'));
                    ds(m,'navid',0);
                    if(!tnav) {
                        tnav = document.createElement('div');
                        tnav.id = 'transnav0';
                        tnav.className = 'transnav';
                        document.body.insertBefore(tnav, document.body.firstChild);
                        tnav.addEventListener('click', (e) => {
                            if(e.target.nodeName !== 'A' && !e.target.closest('.shopoptions')) {
                                const clickedNav = qs('.menu-toggle.selected');
                                if(clickedNav) {
                                    clickedNav.click();
                                }
                            }
                        });
                    }
                    tnav.insertBefore(qs('.shopoptions'), tnav.firstChild);
                    const nls = qa('.navlink',tnav);
                    if(nls.length > 0) {
                        fe(nls, setupnls);
                    }
                    const first =('ul:first-child',tnav);
                    fe(first.children, c => {
                        if(!c.classList.contains('main')) {
                            c.classList.add('main');
                        }
                    });
                    if(!m.classList.contains('jsactive')){
                        m.classList.add('jsactive');
                    }
                    const obc = qs('.basketcorner');
                    const mt = document.createElement('div');
                    mt.className = 'menu-toggle';
                    mt.innerHTML = `<span class="mobileicons">
<a href="tel:01539760650"><span class="icon-phone icon"><i class="alttext">Phone us</i></span></a> 
<a href="/account/"><span class="icon-account icon"><i class="alttext">Your Account</i></span></a> 
<a href="/shop/basket/" id="mobilemb"><span class="icon-basket icon"><i class="alttext">Your Basket</i></span><span class="basketcorner">${obc?obc.textContent:'0'}</span></a>
</span>
<span class="icon">
<span class="line"></span>
</span>
<span class="tog-menu"></span>`;
                    m.insertBefore(mt,m.firstChild);
                    fe(qs('.mobileicons'),mi => {
                        mi.addEventListener('click', e => {
                            e.stopPropagation();
                        });
                    });

                }
                if(!qs('.menu-toggle.selected',m)) {
                    fe(m.children, c => {
                        if(!c.classList.contains('menu-toggle')) {
                            c.style.display = 'none';
                        } else {
                            c.removeEventListener('click', mobileSlideMenuDisplay);
                            c.addEventListener('click', mobileSlideMenuDisplay);
                        }
                    });
                    fe(qa('.menu-toggle a',m), n => {
                        n.addEventListener('click', e => {
                            e.stopPropagation();
                        });
                    });
                }

                qs('.tog-menu',m).textContent = '';

                fe(qa('.mobile_expand_head'), a => {
                    a.removeEventListener('click', mobileHeadClick);
                    a.addEventListener('click', mobileHeadClick);
                    if(!a.classList.contains('active')) {
                        fe(a.parentNode.children, b => {
                            if(b.classList.contains('mobile_expand_body')) {
                                b.style.display = 'none';
                            }
                        })
                    }
                });

                const ca = qa('.categorynav .ul + .ul');
                const tgts = qa('.categorynav .active a');
                fe(ca, (ul,i) => {
                    tgts[i].parentNode.appendChild(ul);
                });

                const stky = qa('.stky');
                window.stkyobs = new IntersectionObserver( stkyobshandler, { threshold: [0,1], rootMargin:"48px 0px 0px 0px" });
                window.bottomstkyobs = new IntersectionObserver( bottomstkyobsHandler, { threshold: [0,1], rootMargin:"48px 0px 0px 0px" });
                fe(stky, s => {
                    if(s.classList.contains('fixbottom')) {
                        bottomstkyobs.observe(s.parentNode);
                    } else {
                        stkyobs.observe(s);
                    }
                });

                viewMode = 'mobile';
            }

        } else {
            if(viewMode != 'desktop' && m) {
                fe(qa('.menu-toggle'),a => {
                    a.parentNode.removeChild(a);
                });
                qs('.siteheader').after(qs('#nav'));
                
                qs('.logo').after(qs('.shopoptions'));
                //qs('.topbar__tagline').insertAdjacentElement('afterend',);
                const es = qs('#expandsubnav');
                fe(qa('.dl',ne),a => {
                    es.appendChild(qs('#navexpanderlist' + ds(a,'list')));
                });
                //qs('.topbar__tagline').insertAdjacentElement('afterend',);
                //Top level nav links e.g Categories, Brands, Need Help
                const nls = qa('.navlink');
                if(nls.length > 0) {
                    fe(nls, setupnls);
                }

                fe(m.children, a => {
                    if(!a.classList.contains('.menu-toggle')) {
                        a.style.display = '';
                        fe(a.children, b => {
                            if(b.classList.contains('icon')) {
                                a.removeChild(b);
                            }
                        })
                    }
                });
                
                fe(qa('.transnav'), a => {
                    a.style.display = '';
                });

                qs('.navholder').style.height = '';

                fe(qa('.mobile_expand_head'), a => {
                    a.removeEventListener('click', mobileHeadClick);
                });
                fe(qa('.mobile_expand_body'), a => {
                    a.style.display = '';
                });


                const ca = qa('.categorynav .ul .ul');
                const tgt = qs('.categorynav .dLoad');
                fe(ca, ul => {
                    tgt.appendChild(ul);
                });

                const stky = qa('.stky');
                w.stkyobs = new IntersectionObserver( stkyobshandler, { threshold: [0,1], rootMargin:"0px 0px 0px 0px" });
                w.bottomstkyobs = new IntersectionObserver( bottomstkyobsHandler, { threshold: [0,1], rootMargin:"0px 0px 0px 0px" });
                fe(stky, s => {
                    if(s.classList.contains('fixbottom')) {
                        if(w.bottomstkyobs) {
                            w.bottomstkyobs.unobserve(s.parentNode);
                        }
                        bottomstkyobs.observe(s.parentNode);
                    } else {
                        if(w.stkyobs) {
                            w.stkyobs.unobserve(s.parentNode);
                        }
                        stkyobs.observe(s);
                    }
                });

                viewMode = 'desktop';
            }
        }

        const resizeChecks = () => {
            if(typeof filterNode == 'undefined') {
                filterNode = qs('.filterpanel');
            }
            if(filterNode && typeof filterNode !== 'undefined') {
                const fh = qa('.filter_head:not(.exp)',filterNode);
                if(fh && fh.length) {
                    fe(fh, h => {
                        h.addEventListener('click',filterHeadClick);
                        h.classList.add('exp');
                        if(!h.classList.contains('active')) {
                            h.nextElementSibling.style.display = 'none';
                        }
                    });
                }
            }

            if(typeof mobileManexpand == 'function') {
                mobileManexpand();
            }

            if(tabsApplied) {
                tabResize();
            }

            // TODO check if this is still used
            /*const ytf = qa('.youtubeframe');
            if(ytf.length > 0) {
                fe(ytf,y => {
                    y.style.height = (y.offsetWidth * 0.558) + "px";
                });
            }
            equalRowHeight(qa('.equals'));*/

            //cabox.init(qa('.fancyexclusive'));

            if(!window.compareset) {
                fe(qa('.comparebtn'),n => {
                    n.removeEventListener('click', window.compareClick);
                    n.addEventListener('click', window.compareClick);
                });
                window.compareset = true;
            }

            positionBasketpop();

            w.checksct();
        }
        if (raf) raf(function() { window.setTimeout(resizeChecks, 10); });
        else window.setTimeout(resizeChecks, 10);
    }
    lastwwidth = wwidth;
}

//Position sticky elements so they stack
let sct = qs('#sctop');
let scttime;

w.checksct = () => {
    if(sct) {
        if(scttime) {
            clearTimeout(scttime);
        } 
        const y = window.scrollY;
        scttime = setTimeout(() => { 
            const stuk = qa('.stuk');
            let sctmt = window.matchMedia('(max-width:947px)').matches?48:0;
            for(let i = 0; i < stuk.length; i++) {
                let s = stuk[i];
                if(!s.classList.contains('fixbottom')) {
                    s.style.top = '';
                }

                if(s && s.classList.contains('fixbottom')?s.getBoundingClientRect().bottom < 0:s.getBoundingClientRect().top <= sctmt) {
                    if(s.classList.contains('fixbottom')) {
                        Object.assign(s.children[0].style,{
                            transform:`translate(0,${sctmt}px)`,
                            transition:'transform 0.2s linear'
                        });
                    } else {
                        Object.assign(s.style,{
                            top:`${sctmt}px`,
                        });
                        if(!s.parentNode.classList.contains('category_right')) {
                            sctmt += s.children[0].offsetHeight;
                        }
                    }
                    s.style.zIndex = 99-i;
                }
            };
            const nstk = qa('.stky:not(.stuk):not(.fixbottom)');
            fe(nstk, (n) => {
                n.style.top = `${sctmt}px`;
            })
            sct.style.transform = `translateY(${sctmt-5}px)`;
        }, 100);
    }
}

// Add to Compare features
window.compareClick = e => {
    let a = e.target;
    if(!a.classList.contains('.comparebtn')) {
        a = a.closest('.comparebtn');
    }
    const par = a.closest('form');
    const prodid = qs('input[name="product_id"]',par).value;
    const title = qs('h2',a.closest('.title'));
    if(typeof gtag == 'function') {
        gtag('event', 'add_to_compare', {'product_id': prodid,'product_name':title.textContent});
    }
    const urlEncodedDataPairs = [];
    const sendData = { product_id:prodid, json:true };
    for(let name in sendData) {
     urlEncodedDataPairs.push(encodeURIComponent(name)+'='+encodeURIComponent(sendData[name]));
    }
    fetch("/products/compare/add.php", {
        method:'POST', 
        headers: {"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"},
        body: urlEncodedDataPairs.join('&')
    })
    .then(res => res.json())
    .then(data => {
        a.removeEventListener('click',compareClick);
        a.addEventListener('click', e => {
            location.href = "/products/compare/";
            e.preventDefault();
            return false;
        });
        if(a.classList.contains('compare_product')) {
            const ic = qs('.icon',a);
            ic.className = ic.className.replace('compare_icon', '') + ' add_confirm';
            fe(qa('.compare_added,.compare_circle,.compare_product'), c => {
                c.classList.add('added_active');
            });
        } else {
            a.innerHTML = 'View Compare <span class="icon-compare icon"></span>';
        }
    });
    e.preventDefault();
    e.stopPropagation();
    return false;
}

//Reposition basket popup on resize
w.positionBasketpop = () => {
    if(typeof clickedButton == 'string') {
        st = window.pageYOffset;
        let targetButton = qs('#' + clickedButton);
        if (targetButton){
            let targetButtonpos = targetButton.getBoundingClientRect();
            const wwidth = lastwwidth;
            const bp = qs('.basketpop');
            if (wwidth > 1015){
                Object.assign(bp.style,{
                    top : `${(targetButtonpos.top + st)}px`,
                    left : `${(targetButtonpos.left - (bp.offsetWidth + 30))}px`,
                    right:'',
                    width : ""
                })
            } else {
                Object.assign(bp.style,{
                    right : `${Math.min(targetButtonpos.right - (targetButton.offsetWidth/2),0)}px`,
                    left:'',
                    top : `${(targetButtonpos.top + targetButton.offsetHeight + 17 + st)}px`,
                    width : (targetButton.offsetWidth*2) + 'px'
                })
            }
        }
    }
}

// Display/Hide mobile navigation
let anbtn;
const mobileSlideMenuDisplay = e => {
    anbtn = e.target;
    let navid = ds(anbtn.parentNode,'navid');;
    while(!navid) {
       anbtn = anbtn.parentNode;
       navid = ds(anbtn.parentNode,'navid');
    }
    if(anbtn.classList.contains('selected')) {
        anbtn.classList.remove("selected");
        slideUp(qs('#transnav'+navid));
    } else {
        anbtn.classList.add("selected");
        slideDown(qs('#transnav'+navid));
    }
    e.preventDefault();
}

// Equal product row section heights
w.equalRowHeight = (nodes, o) => {
    let opts = o?o:{};
    const tallest = [];
    if(nodes && nodes.length > 0) {
        fe(nodes, (n, i) => {
            n.style.height = '';
            if(opts.minHeight) {
                n.style.minHeight = opts.minHeight;
            }
        });
        window.offsetHeight;
        const data = [];
        fe(nodes, (n, i) => {
            if(opts.rowLength) {
                tallest[Math.floor(i/opts.rowLength)] = Math.max(n.offsetHeight, tallest[Math.floor(i/opts.rowLength)] || 0);
            } else {
                const rect = n.getBoundingClientRect();
                const p = rect.top + st; 
                data[i] = Math.floor(p); 
                tallest[Math.floor(p)] = Math.max(n.offsetHeight, tallest[Math.floor(p)] || 0);
            }
        });
        fe(nodes, (n, i) => {
            if(opts.rowLength) {
                n.style.height = tallest[Math.floor(i/opts.rowLength)]+'px';
            } else {
                n.style.height = tallest[Math.floor(data[i])]+'px';
            }
        });
    }
};

let pwrap;

// Simple templating function
w.applyTemplate = (temp, data) => {
    let newText = temp;
    for(let nme in data) {
        let newtext = data[nme] || "";
        if(typeof newtext == 'function') {
            newtext = '';
        }
        newText = newText.replace(new RegExp('{{'+nme+'}}','g'), newtext);
    }
    return newText;
}

/*var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
function getextraletters(num) {
    num = String(num)
    lastDigit = parseInt(num.charAt(num.length-1));
    switch (lastDigit) {
        case 1:
            return num + "st"
            break;
        case 2:
            if(num.length > 1 && parseInt(num.charAt(num.length-2)) == '1') {
                return num + "th";
            } else {
                return num + "nd";
            }
            break;
        case 3:
            if(num.length > 1 && parseInt(num.charAt(num.length-2)) == '1') {
                return num + "th";
            } else {
                return num + "rd";
            }
            break;
        default:
            return num + "th"
            break;
    }
}*/

const displaycookiePrefs = () => {
    const prefarr = cprefs.length == 4?cprefs:[cver,'1','1','1'];
    const cb = qs('.cookiebar');
    const cookiecont = `<div id="cprefs">
<h3>Cookie controls</h3>
<p>You can control which cookies you allow, we use 4 types of cookies</p>
<div class="cpref"><label for="cn"><span>Necessary: <span class="ipop icon info vert" title="These are required and cannot be turned off"></span></span><span class="switch"><input type="checkbox" checked disabled id="cn" value="1" /><span class="slider"></span></span></label></div>
<div class="cpref"><label for="cp"><span>Performance: <span class="ipop icon info vert" title="Site use analysis"></span></span><span class="switch"><input type="checkbox" ${(prefarr[1]=='1'?'checked':'')} id="cp" value="1" /><span class="slider"></span></span></label></div>
<div class="cpref"><label for="cf"><span>Functionality: <span class="icon info vert ipop" title="Online Chat and Google Shopping Guarantee"></span></span><span class="switch"><input type="checkbox" ${(prefarr[2]=='1'?'checked':'')} id="cf" value="1" /><span class="slider"></span></span></label></div>
<div class="cpref"><label for="cad"><span>Advertising: <span class="icon info vert ipop" title="Advertising tracking"></span></span><span class="switch"><input type="checkbox" ${(prefarr[3]=='1'?'checked':'')} id="cad" value="1" /><span class="slider"></span></span></label></div>
<div class="right"><a class="btn" id="csbtn">Save</a></div></div>`;
    const activateCookieForm = () => {
        const csbtn = qs('#csbtn');
        csbtn.addEventListener('click', () => {
            const ccont = qs('#cprefs');
            const p = qs('#cp',ccont).checked?1:0;
            const f = qs('#cf',ccont).checked?1:0;
            const ad = qs('#cad',ccont).checked?1:0;
            cprefs = [cver,p,f,ad];
            document.cookie=`cookienotified=${cprefs.join(',')}; path=/; expires=Thu, 31 Dec 2099 23:59:59;samesite=lax`;
            if(cb) {
                cb.parentNode.removeChild(cb);
            }
            if(typeof cabox != 'undefined') {
                cabox.closeBox();
            }
            if(p) {
                funcCook();
                gtag('consent', 'update', {'analytics_storage': 'granted'});
                window.uetq.push('consent', 'update', {'ad_storage': 'granted'});
            } else {
                gtag('consent', 'update', {'analytics_storage': 'denied'});
                window.uetq.push('consent', 'update', {'ad_storage': 'denied'});
            }
            if(ad) {
                gtag('consent', 'update', {'ad_storage': 'granted','ad_user_data':'granted','ad_personalization':'granted'});
            } else {
                gtag('consent', 'update', {'ad_storage': 'denied','ad_user_data':'denied','ad_personalization':'denied'});
            }
            if(f) {
                optionalFunc();
            }
        });
    }
    const cookiediv = qs('#ccustom');
    if(cb) {
        const o = {
            content:cookiecont,
            maxwidth:'340px',
            onComplete:() => {
                for(let i = 0;i < w.caboxPoppedFunctions.length;i++) {
                    w.caboxPoppedFunctions[i]();
                }
                activateCookieForm();
            }
        }
        cabox.init(null,o);
    } else {
        cookiediv.innerHTML = cookiecont;
        activateCookieForm();
    }
    ipopSetup('#cprefs');
}

// Get query string parameters
w.getParameterByName = name => {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    const results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

// Scroll to element that matches selector
w.scrollToSel = sel => {
    st = window.pageYOffset;
    const n = typeof sel == 'string'?qs(sel):sel
    const pos = n.getBoundingClientRect();
    const nph = qs('.navplaceholder');
    if(nph) {
        const navoff = nph.getBoundingClientRect();
        if(navoff.top < pos.top) {
            pos.top -= nph.offsetHeight;
        }
    }
    let targettop = pos.top + st;
    let fixedheights = 0;
    const stickys = qa('.stky');
    fe(stickys, a => {
        const ppos = a.parentNode.getBoundingClientRect();
        if((a.classList.contains('fixbottom')?ppos.bottom:ppos.top) + st < targettop) {
            fixedheights += a.closest('.actions')?70:a.offsetHeight;
        }
    });
    targettop -= fixedheights;
    goToScrollTop(targettop);
}

// Animate scroll to position
const goToScrollTop = tgt => {
    if('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({
            top:tgt,
            left:0,
            behavior:'auto'
        });
    } else {
        window.scrollTo(0,tgt);
    }
}

const goToScrollLeft = (el, tgt) => {
    if('scrollBehavior' in el.style) {
        el.scrollLeft = tgt;
    } else if(el.scrollTo) {
        el.scrollTo({
            left:tgt,
            behavior:'auto'
        });
    } else {
        el.scrollLeft = tgt; 
    }
}

//Get index of element within it's parent
w.index = el => {
    return Array.from(el.parentNode.children).indexOf(el);
}
// Get element height even if hidden
const getElHeight = el => {
    if(el.offsetHeight > 0) {
        return el.offsetHeight;
    } else {
        const els = el.currentStyle || window.getComputedStyle(el);
        const oldStyle = {
            height: els.height,
            overflow: els.overflow,
            display: els.display
        }
        Object.assign(el.style, {
            height:'0px',
            overflow:'hidden',
            display:'block'
        });
        let height = el.scrollHeight;
        const maxHeight = parseFloat(els.maxHeight.replace('px',''));
        if(height > maxHeight) {
            height = maxHeight;
        }
        Object.assign(el.style, oldStyle);
        return height;
    }
}

// Slide in and out functions
let slideDownTime;
let lastSlideDown;
let lastSlideEl;
w.slideDown = (el, time, callback) => {
    const tgt = getElHeight(el);
    Object.assign(el.style, {
        overflow:'hidden',
        height:'0px',
        display:'block',
        transition:'height 0.1s ease-in-out'
    });
    el.offsetHeight;
    el.style.height = tgt + 'px';
    lastSlideDown = () => {
        Object.assign(el.style, {
            overflow:'',
            height:'',
            transition:''
        });
        if(callback) {
            callback();
        }
    }
    if(slideDownTime && lastSlideEl == el) {
        clearTimeout(slideDownTime);
        lastSlideDown();
    }
    if(slideUpTime && lastSlideEl == el) {
        clearTimeout(slideUpTime);
        lastSlideUp();
    }
    lastSlideEl = el;
    setTimeout(lastSlideDown, time || 100);
}

let slideUpTime;
let lastSlideUp;
w.slideUp = (el, time, callback) => {
    const tgt = getElHeight(el);
    Object.assign(el.style, {
        overflow: 'hidden',
        height:tgt + 'px',
        transition:'height 0.1s linear'
    });
    el.offsetHeight;
    el.style.height = '0px';
    lastSlideUp = () => {
        Object.assign(el.style, {
            overflow:'',
            height:'',
            transition:'',
            display:'none'
        });
        if(callback) {
            callback();
        }
    }
    if(slideDownTime && lastSlideEl == el) {
        clearTimeout(slideDownTime);
        lastSlideDown();
    }
    if(slideUpTime && lastSlideEl == el) {
        clearTimeout(slideUpTime);
        lastSlideUp();
    }
    lastSlideEl = el;
    setTimeout(lastSlideUp, time || 100);
}


// Fade in and out features
const fadeTimers = [];
let timerID = 0;
w.fadeOut = (n, t, c) => {
    if(fadeTimers && ds(n,'timerID')) {
        clearTimeout(fadeTimers[ds(n,'timerID')]);
    }
    n.classList.add('fadeIn','fadeReady');
    timerID++
    ds(n,'timerID',timerID);
    setTimeout(() => {
        n.classList.remove('fadeIn');
    },0);
    fadeTimers[timerID] = setTimeout(() => {
        n.style.display = 'none';
        n.classList.remove('fadeReady');
        if(c) {
            c();
        }
    }, t || 100);
}
w.fadeIn = (n, t, c) => {
    if(fadeTimers && ds(n,'timerID')) {
        clearTimeout(fadeTimers[ds(n,'timerID')]);
    }
    if(!n.classList.contains('fadeReady')) {
        n.classList.add('fadeReady');
    }
    n.style.display = 'block';
    timerID++
    ds(n,'timerID',timerID);
    setTimeout(() => {
        n.classList.add('fadeIn');
    },0);
    fadeTimers[timerID] = setTimeout(() => {
        n.classList.remove('fadeIn');
        n.classList.remove('fadeReady');
        if(c) {
            c();
        }
    }, t || 100);
}

// Form to json
w.serializeObject = form => {
    const obj = {};

    ap.slice.call(form.elements).forEach(field => {
        if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;

        if (field.type === 'select-multiple') {
            const options = [];
            ap.slice.call(field.options).forEach(option => {
                if (!option.selected) return;
                options.push(option.value);
            });
            if (options.length) {
                obj[field.name] = options;
            }
            return;
        }

        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
        if(field.name.indexOf('[]') > - 1) {
            if(obj[field.name]) {
                obj[field.name].push(field.value);
            } else {
                obj[field.name] = [field.value];
            }
        } else {
            obj[field.name] = field.value;
        }
    });
    return obj;
};

w.loadJS = (url, implementationCode, location) => {
    //url is URL of external file, implementationCode is the code
    //to be called from the file, location is the location to 
    //insert the <script> element

    const scriptTag = document.createElement('script');
    const urlMatch = url.match(/(\/?)assets\/shop\/js\/([a-zA-Z0-9\.]+).js/);
    if(urlMatch) {
        scriptTag.src = `${urlMatch[1]}assets/shop/js/${legacy}${urlMatch[2]}.js`
    } else {
        scriptTag.src = url;
    }

    if(implementationCode) {
        scriptTag.onload = implementationCode;
        scriptTag.onreadystatechange = implementationCode;
    }

    if(!location) {
        document.head.appendChild(scriptTag);
    } else {
        location.appendChild(scriptTag);
    }
};

// Product rendering functions

w.specids = [];

const mainimg = '<a href="{{url}}" onclick="prodC({{product_id}},this,\'Image Link Button\');"><div class="img-frame"><img src="{{src}}" alt="Image of {{alt}}" width="142" height="158" loading="lazy" /></div></a>';

const rrpsave = (o,n,l,v) => {
return `<div class="rrpsave exvat"><div>${l}:<br /><span class="rrp_price">&pound;${currencyPad(o)}</span></div><div>SAVE:<br /><span class="save_price">&pound;${currencyPad(o - n)}</span></div></div><div class="rrpsave incvat"><div>${l}:<br /><span class="rrp_price">&pound;${currencyPad(o*v)}</span></div><div>SAVE:<br /><span class="save_price">&pound;${currencyPad((o*v) - (n*v))}</span></div></div>`;
}

w.populateProduct = (p,n) => {

    let loader = qs('.loader',n);
    if(loader) {
      loader.parentNode.removeChild(loader);
    }
    if(!n.querySelector('.img')) {
      const s = document.createDocumentFragment();
      if(p.manufacturer_id != 209) {
        p.product_name = p.manufacturer_name + ' ' + p.product_name;
      }

      const img = document.createElement('div');
      img.className = 'img';
      let pi = p.primary_image;
      if(Array.isArray(pi)) {
        pi = pi[0];
      }

      img.innerHTML = applyTemplate(mainimg, {
        url:p.url,
        product_name:p.product_name,
        product_id:p.product_id,
        src:pi && pi.medium_thumb_url?pi.medium_thumb_url:'/images/sorry-no-image-available.gif',
        alt:pi?p.product_name:'Sorry no image available'
      });
      s.appendChild(img);

      let pp;
      let pwrslg = '';
      switch(p.product_power_supply) {
        case "Plug in":
          pwrslg = '13-amp';
          break;
        case "Plug in & Hardwired":
          pwrslg = 'electric-plug';
          break;
        case "Natural Gas":
          pwrslg = 'natural-gas';
          break;
        case "Propane Gas":
          pwrslg = 'lpg-propane';
          break;
        case "Dual Fuel":
          pwrslg = 'dual-fuel';
          break;
        case "Battery":
          pwrslg = 'battery';
          break;
        case "Rechargable Battery":
        case "Rechargeable Battery":
          pwrslg = 'battery-rechargable';
          break;
        case "Single Phase 16 Amp Commando Plug":
        case "3 Pin Commando Plug":
          pwrslg = 'commando-plug';
          break;
        case "5 Pin Commando Plug":
          pwrslg = '5-pin-commando-plug';
          break;
        case "3 Phase":
        case "Hardwired":
          pwrslg = 'electric';
          break;
      }
      if(pwrslg != '') {
        pp = document.createElement('img');
        pp.src = asc+'/shop/img/ps-' + pwrslg + '.svg';
        pp.alt = pp.title = p.product_power_supply.replace('Plug in','Standard Plug');
        pp.loading = 'lazy';
        pp.width = pp.height = 60;
        pp.className = 'pwr';
        img.appendChild(pp);
      }

      let availclass = "nostock";
      let iconclass = 'nostockicon';
      let stocktext = p.product_stock;
      switch(p.product_stock) {
        case "In Stock":
          availclass = "stock";
          iconclass = 'stockicon';
          break;
        case "Out of Stock (Due Soon)":
          if (p.product_stock_leadtime_days) {
            availclass = "preorder colour";
            iconclass = 'preorder colour';
            stocktext = "Order Now";
          } else {
            availclass = "preorder";
            iconclass = 'preorder';
            stocktext = "Pre-order";
          }
          break;
      }
      const stck = document.createElement('div');
      stck.classList.add('stkho');
      stck.innerHTML = '<span class="'+iconclass+' icon"></span><span class="'+availclass+'">'+stocktext+(p.delivery_flags && p.delivery_flags.store_collection?'<span class="icon-cac icon" title="Available for click and collect"></span>':'')+'</span>';
      
      if(iconclass.indexOf('preorder') > -1 && p.product_stock_date) {
        const availtext = document.createElement('div');
        availtext.className = "availtext";
        const availdate = p.product_stock_date.split('-').reverse();
        availtext.textContent = 'Dispatch from ' + availdate.join('/');
        stck.appendChild(availtext); 
      }

      /*if(availclass == 'stock' && p.next_day_delivery) {
        const nxtday = document.createElement('div');
        nxtday.innerHTML = applyTemplate('<div class="clearspace"></div><a href="{{url}}" onclick="prodC({{product_id}},this,\' View this Product link\', \'Get tomorrow\');"><img src="'+asc+'/shop/img/{{fndd}}next-day-delivery-icon.webp" srcset="'+asc+'/shop/img/{{fndd}}next-day-delivery-icon_hr.webp 2x" loading="lazy" alt="{{tfndd}}Next day delivery available" class="ndd" /></a>',{url:p.url,product_name:p.product_name,product_id:p.product_id,tfndd:(p.next_day_delivery_free?'Free ':''),fndd:(p.next_day_delivery_free?'free-':'')});
        stck.appendChild(nxtday);
      }*/

      const noManLogo = [209,248,156,193];
      const losl = document.createElement('div');
      losl.className = 'statuslogos';

      const manp = document.createElement('div');

      if(noManLogo.indexOf(p.manufacturer_id) == -1) {
        const manlogpic = document.createElement('picture');
        const manlog = document.createElement('img');
        manlog.src = p.brand_logo_url;
        manlog.alt = p.manufacturer_name;
        manlog.className = 'brandlogo';
        manlog.loading = 'lazy';
        manlogpic.appendChild(manlog);
        manlog.width = p.manufacturer_logo_width;
        manlog.height = p.manufacturer_logo_height;
        manlog.style.width = p.manufacturer_logo_width + 'px';
        manlog.style.height = p.manufacturer_logo_height + 'px';
        manp.appendChild(manlogpic);
        losl.appendChild(manp);
      }


      if(p.special_offer_image && p.product_stock == 'In Stock' && n.className.indexOf('noc') == -1) {
        const so = document.createElement('div');
        so.className = 'infoitem';
        so.innerHTML = `<span class="infoitem">${p.special_offer_name.indexOf('World Cup') > -1?'<span class="icon-football icon"></span>':''}${p.special_offer_name }</span>`;
        losl.appendChild(so);
      }

      let specs;
      const desc = document.createElement('div');
      desc.className = 'desc';
      if(p.specs && !p.product_specs_index) {
        p.product_specs_index = {};
        fe(p.specs,s => { p.product_specs_index[s.spec_id] = {
            "specification_name":s.spec_name,
            "display_text":s.value_string
        }});
      }
      if(p.product_specs_index) {
        specs = '<div class="specs">';
        let specCount = 0;
        let specsVals = [];
        if(typeof specids != 'undefined' && specids.length > 0) {
          specids.forEach(i => {
            const spec_val = p.product_specs_index[i];
            if(spec_val) {
              specsVals.push(spec_val);
            }
          });
        } else {
          fe(Object.keys(p.product_specs_index), key => {
            const spec_val = p.product_specs_index[key];
            if(spec_val) {
              specsVals.push(spec_val);
            }
          });
        }
        let exc = [{t:'Height (External)',s:'(H)'},{t:'Length (External)',s:'(L)'},{t:'Width (External)',s:'(W)'},{t:'Depth (External)',s:'(D)'},{t:'Diameter',s:'(Ø)'}];
        let vardimcount = 0;
        let specdims = [];
        let unit = '';
        fe(specsVals, spec_val => {
          let s = exc.find(s => spec_val.specification_name == s.t);
          if(s) {
            specdims.push(spec_val.display_text.replace(/Â/g,'&nbsp;').replace(/[^0-9]+$/g,'') + s.s);
            if(unit === '') {
              unit = spec_val.display_text.match(/([^0-9 ]+)$/);
            }
            if(spec_val.display_text === 'Various') {
              vardimcount++;
            }
          }
        });
        let sizeShown = false;
        fe(specsVals, spec_val => {
          if(exc.map(s => s.t).includes(spec_val.specification_name) && specdims.length > 0) {
            if(!sizeShown) {
              specs += `<div class="spec ui"><strong>Dimensions:</strong> ${vardimcount == specdims.length?'Various':`${specdims.join(' x ')}${unit&&unit.length>1?unit[1]:'mm'}`}</div>`;
              specCount++;
              sizeShown = true;
            }
          } else if(spec_val.specification_name != 'Dimensions' || (spec_val.specification_name == 'Dimensions' && specdims.length == 0)) {
            specs += `<div class="spec ui"><strong>${spec_val.specification_name}:</strong> ${spec_val.display_text.replace(/Â/g,'&nbsp;')}</div>`;
            specCount++;
          }
        });
        specs += '</div>';
        desc.innerHTML = specs;
      } else {
        desc.innerHTML = '<div class="specs"></div>';
      }

      const avails = document.createElement('div');
      avails.className = 'avails';
      avails.appendChild(stck.cloneNode(true));

      const action = document.createElement('div');
      action.className = 'action';
      const lastdetail = document.createElement('div');
      lastdetail.className = 'lastdetails';

      if(p.product_stock != "Unavailable") {
        if(p.product_stock != 'Discontinued') {
          const offr = document.createElement('div');
          offr.className = 'offer cs';
          if(p.product_poa == 'Yes') {
            offr.innerHTML = '<p>Call to Order</p><a href="tel:01539 760 650" class="btn bbtn phonenumber"><strong>01539 760 650</strong></a>';
          } else {
            let offrhtml = '<div class="exvat"><strong>&pound;' + currencyPad(p.product_price) + '</strong> <span class="vattag">ex. VAT</span>';
            offrhtml += '</div><div class="incvat"><strong><span class="colour">&pound;'+currencyPad(p.product_price*(1+Number(p.vat_rate_value))) + '</span></strong> <span class="vattag">inc. VAT</span>';
            offrhtml += '</div>';
            offr.innerHTML = offrhtml;
          }
          lastdetail.appendChild(offr);
        }
      }

      if(p.product_energy_rating && p.product_energy_rating != '') {
        const cateff = document.createElement('div');
        cateff.className ='catefficiency';
        let cateffhtml = '';
        const o = {
          e:'Energy Efficiency Rating'
        }
        if(p.product_energy_rating_range) {
          o.to = product_energy_rating_range.to;
          o.toc = o.to.replace(/\+/g,'p');
          o.from = product_energy_rating_range.from;
          o.fromc = o.from.replace(/\+/g,p);
          cateffhtml = applyTemplate('<div><span class="enr rate{{fromc}}" title="{{e}}: {{from}}"><span>{{e}}: </span>{{from}}</span></a></div><div class="clearbit"></div><div class="smaller">to</div><div class="clearbit"></div><div><a href="{l}}"><span class="enr rate{{to}}" title="{{e}}: {{to}}"><span>{{e}}: </span>{{to}}</span></div>',o);
        } else {
          o.r = p.product_energy_rating;
          o.rc = o.r.replace(/\+/g,'p'); 
          cateffhtml = applyTemplate('<span class="enr rate{{rc}}" title="{{e}}: {{r}}"><span>{{e}}: </span>{{r}}</span>',o);
        }
        cateff.innerHTML = cateffhtml;
        img.appendChild(cateff);
      }
      if(p.product_review_stars) {
        const rvw = document.createElement('div');
        rvw.className = 'reviews cs';
        rvw.innerHTML = `<a href="${p.url}#reviews" class="icon-stars star${p.product_review_stars*2}" title="${p.product_review_stars} star reviewed"><em><span></span></em></a>`;
        lastdetail.appendChild(rvw);
      }
      /*if(p.graded_id && Number(p.product_price_new) < Number(p.graded_price)) {
        var gd = document.createElement('div');
        gd.className = 'padesc rrpsaveholder';
        gd.innerHTML = rrpsave(p.product_price_new, p.graded_price,'NEW',(1+Number(p.vat_rate_value)));
        lastdetail.appendChild(gd);
      }*/
      if(p.product_rrp > 0 && Number(p.product_rrp) > Number(p.product_price) && p.product_poa != "Yes" && p.product_stock != "Discontinued") {
        const prrp = document.createElement('div');
        prrp.className = 'padesc rrpsaveholder';
        prrp.innerHTML = rrpsave(p.product_rrp,p.product_price,'RRP',(1+Number(p.vat_rate_value)));
        lastdetail.appendChild(prrp);
      }


      action.appendChild(stck);

      action.appendChild(lastdetail);

      const m = document.createDocumentFragment();
      m.appendChild(avails);
      m.appendChild(action);
      const ntitle = qs('.title',n);
      ntitle.appendChild(losl);
      ntitle.appendChild(desc);
      n.firstChild.insertBefore(s, n.firstChild.firstChild);
      n.firstChild.appendChild(m);
      n.classList.add('popt');
    }
}



w.setupIncrementors = selector => {
    const incrementors = qa(selector + ' .incrementor');
    fe(incrementors, incs => {
        const incsinp = qs('input',incs);
        if(!incsinp.classList.contains('scripted')) {
            incsinp.classList.add('scripted');
            const minus = document.createElement('span');
            minus.className = 'minusinput';
            minus.textContent = '-';
            const plus = document.createElement('span');
            plus.className = 'plusinput';
            plus.textContent = '+';
            incsinp.insertAdjacentElement('beforebegin', minus);
            incsinp.insertAdjacentElement('afterend', plus);
            if(incsinp.type == 'number') {
                incsinp.type = 'text';
            }
            if(!incsinp.min) {
                incsinp.min = 0;
            }

            minus.addEventListener('click', () => {
                const newval = parseInt(incsinp.value);
                incsinp.value = Math.max(newval-1, parseInt(incsinp.min));
                triggerEvent(incsinp,'change');
                incsinp.blur();
            })
            plus.addEventListener('click', () => {
                const newval = parseInt(incsinp.value);
                incsinp.value = Math.max(newval+1);
                triggerEvent(incsinp,'change');
                incsinp.blur();
            });
            incsinp.addEventListener('keypress', (e) => {
                return e.charCode >= 48 && e.charCode <= 57;
            });
            incsinp.addEventListener('change', (e) => {
                incsinp.value = parseInt(incsinp.value.replace(/\D/g,'') || 0);
            });
        }
    });
}

scriptReady = true
if(pageReady && cssReady) {
    activatePage();    
} else {
    document.addEventListener('DOMContentLoaded', () => {
        if(pageReady && cssReady) {
            activatePage();
        } else {
            const actpageint = setInterval(() => {
                if(pageReady && cssReady) {
                    clearInterval(actpageint);
                    activatePage();
                }
            }, 50);
        }
    });
}
if(pageLoaded) {
    pageLoadComplete()
} else {
    window.addEventListener('load',pageLoadComplete);
}